module.exports = {
  "Gattaran_optimization_yGvp_jOAe": "Confirmar",
  "Gattaran_form_tLLN_yhWQ": "La información sobre una persona de contacto de uso frecuente se completará automáticamente. Puedes dar clic para editar la información.",
  "Gattaran_V1__YaIb": "En línea",
  "FoodB_2_Please_select_Mixz": "Selecciona",
  "Internal_Tools_0523_GtzK_ZoJh": "No se han unido eventos elegibles. Solicite en la tienda para unirse al evento de autopromoción.",
  "FoodOpB_Translation_Maestra_Accounts_ktyA": "Cuenta maestra",
  "FoodB_0617_DewC_iPTt": "Pedidos completados por día con la competencia - R",
  "FoodOpB_management_Special_rules_PdhA": "Reglas especiales",
  "FoodB_up20241218_aEPD_NaLf": "Seleccionar productos",
  "FoodB_Commision_Add_MPEf": "Agregar",
  "FoodC_202408_wten_GUVt": "Selecciona la dirección de entrega",
  "FoodB_calculator_CXvv_RJgQ": "Monto a recibir antes de impuestos y comisión",
  "FoodB_tagging_You_chose_OMGB": "Decidiste invalidar este socio potencial por el siguiente motivo: \"La tienda no existe\". Para hacerlo, debes cargar una foto.",
  "FoodB_calculator_gRHL_Sgok": "Margen de utilidad",
  "FoodB_collection_11_digits_QhYs": "Debe contener 11 dígitos sin espacio",
  "FoodOpB_management104_Coordinator_endx": "Coordinator account",
  "Help_V4_Enter_the_xqlm": "Ingresa un número de teléfono válido.",
  "Gattaran_transformation__TnQQ": "Asociar nuevo signatario",
  "Gattaran_merchantfee2_sTmZ_koaw": "El valor ingresado no puede ser menor de {{min}}",
  "FoodB_0_Please_upload_ziBz": "Carga una captura de pantalla del historial de llamadas",
  "FoodB_phrase__NpWx": "Sólo promos finalizadas en los últimos {{number}} meses",
  "FoodOpB_1_Expired_rTXx": "Caducada",
  "FoodB_202303_YWUL_hwNF": "Aceptar",
  "FoodC_Storefront_iOFy_aaef": "Esta tienda no participa en esta promoción",
  "FoodB_0617_pLtb_hIQz": "Pedidos completados por día con la competencia - U",
  "Gattaran_0_Clerk_tends_QpMA": "Método de contacto preferido del empleado",
  "FoodB_Show_Store_Direct_GuJM": "Contrato firmado mediante B-App",
  "FoodOpB_Management_Appeals_foxk": "Solicitar revisión",
  "FoodB_optimization__bdZL": "La imagen debe tener un formato JPG o PNG, pesar menos de 5 MB y ser de al menos 200×200 píxeles.",
  "Gattaran_management_NjMN_zyWQ": "Programada · {{date}}",
  "soda-c-i18n---个人中心的“优惠券”": " Mi Perfil > Cupones.",
  "FoodB_1106_FGdT_UxXY": "Generando resumen de IA",
  "Gattaran_opt_swMT_sNcV": "Combo de promoción",
  "Gattaran_20240401_rbqe_PoaI": "Esta encuesta es obligatoria",
  "FoodC_sales_Confirmation_mTGd": "Entendido",
  "FoodOpB_v2_Data_update_YmPK": "Hora de actualización de los datos",
  "FoodB_v1_Sources_of_DsXR": "Fuente de información",
  "Gattaran_transformation__LMJQ": "El signatario firmó el contrato. Agrega la tienda en Gattaran.",
  "soda-c-i18n---现金": "Efectivo",
  "FoodB_202502_ldlj_sqzT": "Enviar",
  "FoodB_20260130_bbxn_DGDm": "Puntuación total",
  "FoodB_1__gcdX": "Datos del evento",
  "FoodD_payout_Account_Type_YmVW": "Tipo de cuenta",
  "Gattaran_statusbar2_eoSG_yEDD": "Aprobada",
  "Gattaran_record_IcKI_Jklz": "Editar visita",
  "Gattaran_84_iOCg_cQuB": "Detalles de la infracción",
  "FoodB_email_CBNM_cSdr": "Correo electrónico",
  "FoodB_V2_Illegal_companies_pXwb": "No registrada legalmente",
  "FoodOpB_1_New_visits_HXsz": "Crear visita",
  "FoodC_sidebar_Use_the_huoZ": "Pide cuando quieras, donde quieras",
  "CS_Aftersale_Wrong_meal_gNCe": "Producto(s) incorrecto(s)",
  "FoodB_management_Automatic_Switching_ghJS": "Apertura/cierre automático de la tienda",
  "FoodC_education_3_If_wduh": "3. Si un inconveniente relacionado con la entrega sucede por razones ajenas a factores humanos, como problemas con el producto o el mal clima, se considerará responsabilidad de la plataforma.",
  "Gattaran_202406_eUIt_lfFS": "Completada",
  "Gattaran_url_nvGh_CcGr": "La URL debe comenzar con http:// o https://",
  "Gattaran_0__Yqcw": "No hay más tiendas en el área actual",
  "FoodB_Translation_fqel_jrJX": "Imágenes probatorias (opcional)",
  "FoodB_communications_nVMa_oikA": "Impulso para tiendas nuevas",
  "FoodB_audit_Store_Information_ryuV": "Se realizó una revisión de la información modificada de la tienda",
  "Gattaran_form_xrZg_zpSi": "Resultado",
  "FoodC_202410_ZHQi_kNsP": "Editar",
  "FoodC_c_Completed_djPp": "Finalizado",
  "Gattaran_0516_AZMU_LSZh": "Tiendas registradas",
  "FoodB_list_Recently_launched_IWDa": "Última vez conectada",
  "Gattaran_add_vitO_CCPh": "Cobertura de foto >= 60%",
  "FoodB_Contract_CqnW_XWkx": "Recompensa de tarifa de servicio en el acuerdo",
  "FoodOpB_1_Seven_days'_LZwW": "Dentro de los próximos 7 días",
  "FoodB_v4_Ofdy_csVK": "Cobertura de fotos de productos del menú",
  "FoodC_202408_qXNe_iBNs": "No se pudo obtener la ubicación actual",
  "更多": "More",
  "Gattaran_202406_lujp_fWRq": "Descripción de la tarea",
  "FoodB_1__IhgO": "Actualizado el {{time}}",
  "FoodB_0617_EuIs_mugQ": "¿Cuántos pedidos con entrega a domicilio realiza el restaurante por día?",
  "Gattaran_0__VRqN": "Se cargaron todas las tiendas",
  "FoodOpB_1_Close_visit_ttxh": "Cerrar confirmación de visita",
  "Gattaran_side__MIpl": "Viernes",
  "FoodC_Website_From_shop_Jatv": "Realiza un pedido a [shop name] | DiDi Food",
  "Gattaran_optimization_oRge_RkDM": "Tareas de visitas completadas · {{month}}",
  "Gattaran_Optimization_zZhD_VHmE": "Ver dirección de la tienda y habilitar navegación",
  "FoodB_SMS__promotion_EKZy": "Promoción de entrega sin costo",
  "FoodB_V1_oOpd_aRtv": "No completada",
  "FoodB_up250108_BLxC_rIzf": "Ver después",
  "FoodC_202412_DMKw_kWMA": "Intenta buscar la calle y número",
  "FoodB_1106_fJJY_Hpvo": "Volver a grabar",
  "Gattaran_visit_zdKK_wwRk": "Resultados de la visita",
  "Gattaran_opt_cWad_xQOF": "Imperfección Ordens",
  "FoodB_audit_Review_process_vGtV": "proceso de revisión. ¿Estás seguro de que quieres continuar?",
  "Gattaran_84_fQos_Hkqg": "Recordatorio",
  "FoodC_20240607_ffiX_wNQG": "WhatsApp",
  "FoodB_20250122_FReB_KjrR": "Completador de la tarea",
  "Gattaran_Gattaran__OuWt": "Total de horas en línea",
  "FoodB_collection_idCIF_qqcc": "idCIF",
  "FoodB_IGV_iopU_urly": "Tasa de IGV",
  "FoodB_calculator_vEpj_lLGl": "Descuento total",
  "FoodB_0_WhatsApp_dmMD": "WhatsApp",
  "FoodD_Name_October_WGkU": "Oct",
  "FoodC_202412_QJMa_Qkwg": "Ingresa una nueva dirección de entrega para agregarla",
  "Gattaran_opt_RltV_fDyM": "Producto en promoción (sin combo)",
  "FoodB_document_vGTm_pEcu": "El archivo que se cargará no puede superar los {{limit}} MB. Por favor, vuelve a cargarlo.",
  "FoodB_Show_Tax_payment_xfxh": "Forma de pago de impuestos (Nacional)",
  "Gattaran_Visit_Visiting_Process_KFJZ": "Calificación de la reunión con la persona a visitar",
  "FoodB_V1_uXrr_bWox": "Puedes administrar o restablecer los filtros aquí",
  "确认": "Subir",
  "FoodB_communications_HAnw_bYAw": "tiendas con acciones incompletas",
  "FoodC_education_3_Customers_Zoec": "3. Para que el socio repartidor pueda contactarte si lo necesita, procura tener tu teléfono a la mano durante la entrega.",
  "Gattaran_KPI4_Sjnd_VzaZ": "Alerta de tienda",
  "FoodB_1106_tawV_utGy": "Pasos siguientes",
  "Gattaran_function__iTSm": "Versión",
  "FoodC_202412_kamX_bNUi": "Por favor, selecciona una dirección para agregar",
  "FoodC_20240607_fIqe_iMtS": "Aceptar",
  "FoodB_2_Store_XkLQ": "Tienda",
  "FoodB_0622_Select_up_QXDl": "Selecciona hasta 2 tiendas",
  "FoodB_1106_isfE_qwXl": "Cargando archivo de voz. No cierres esta página",
  "FoodC_edit_NDmM_lEJY": "Encontrarse en la puerta",
  "FoodC_202408_HfXO_xbcw": "Ver",
  "Gattaran_202406_jhpc_QSnv": "Información de referencia",
  "FoodB_tagging_You_chose_aZCG": "Decidiste invalidar este socio potencial por el siguiente motivo: \"Operaciones detenidas\". Para hacerlo, debes estar a menos de {{distance}} de la tienda. Verifícalo e inténtalo de nuevo.",
  "FoodC_education__1_vwgm": "(1) Entregar en la puerta",
  "Gattaran_management_sGBh_ExWD": "Horario de operación",
  "FoodB_resivion_Feedback_to_QmQU": "Repórtalo a tu supervisor para que la modifique",
  "FoodB_task_BFBu_ONmI": "Tarea no ejecutada",
  "FoodB_0926__Jfhv": "No hay promociones con este estado",
  "FoodB_0617_qpbP_bnWv": "Pedidos completados por día - Entrega de la tienda",
  "FoodC_perception_Tips_hZWk": "Agradecimiento",
  "Gattaran_0410_hDTJ_vhKk": "Haz clic aquí para ver la información detallada sobre el rendimiento.",
  "FoodB_0907__jtsj": "No hay datos del diagnóstico",
  "FoodB_20260130_aGfa_zSww": "Profundizar en la escucha activa",
  "FoodB_20250122_IbZs_wRcg": "Reenviar la tarea si sigue sin completarse a los X días de su creación",
  "Gattaran_0_Need_to_uMbb": "Se revisara con el DM",
  "FoodB_group0901_tZIs_QwiK": "Postulado",
  "Gattaran_Visit_Evaluation_eRDU": "Autoevaluación",
  "FoodC_optimization_rmLx_bSmk": "Busca tu dirección de entrega y agrégala",
  "Gattaran_optimization_mtXy_iWsc": "Selecciona entre 2 opciones",
  "Gattaran_0_Salesmen_tend_hFQf": "Mejor hora de contacto del empleado",
  "FoodB_Show_Foreign_DIMEX_LKxF": "DIMEX",
  "FoodC_education_Meal_picking_ziun": "Reglas con respecto a la entrega",
  "Gattaran_subsidy_wnTI_MvfU": "Error al agregar. Esta entidad ha tenido un contrato de exclusividad con una recompensa de tarifa de servicio.",
  "Gattaran_0_Agree_gCQO": "Acuerdo cerrado",
  "FoodC_revision_Contact_customer_XbFk": "Contáctanos",
  "FoodB_1106_UJYm_mRFD": "Puedes editar el contenido generado por IA y enviar la grabación final tras la confirmación.",
  "FoodC_shop__hSnf": "Queda(n) {{num}}",
  "FoodOpB_Management_High_similarity_lnFn": "Ya existe una tienda similar",
  "FoodB_Launch_DR_Passport_JChW": "Pasaporte",
  "Gattaran_Visit_Change_1_LYvR": "Cambio 1",
  "FoodC_202410_mjfG_DDhf": "Agregar",
  "FoodB_0905__yxOa": "Sin cambios",
  "FoodC_improvement_Rgol_abYw": "Se envió tu solicitud de cancelación y la tienda la procesará en un plazo de {{XminYs}}. Gracias por esperar.",
  "FoodB_survey_IQBT_jfZq": "Fecha de vencimiento del contrato de exclusividad con el competidor – P",
  "Gattaran_v1_Whrf_ZdCg": "No registrado. Regístrate en la app DiDi Tienda",
  "Gattaran_0_Is_the_dYmK": "Dificultad de navegación del menú",
  "Gattaran_Homepage__bYLT": "Página de inicio",
  "Gattaran_0_The_end_KvBf": "La hora de finalización debe ser posterior a la hora de inicio",
  "FoodB_B86_bcPL_fkRh": "Problemas pasados",
  "Gattaran_visit_Wpaf_mvuG": "El BD cerró los acuerdos exitosamente",
  "Gattaran_Top_Qwud_sgUf": "2. La etiqueta DiDi Top de la tienda se actualiza los días 2 y 17 de cada mes.",
  "Gattaran_84_RhFf_bZsT": "Tipo de infracción",
  "Groceries_shop2_Fwyu_yymq": "Sólo se pueden agregar hasta {{num}} productos al carrito.",
  "FoodB_1106_vPRw_ajcX": "¿Confirmas que deseas eliminar la grabación?",
  "Gattaran_AlertV1_ADYi_okAH": "Aceptar",
  "Gattaran_V1_DJia_IZfI": "Finalización",
  "FoodB_20260130_lYVk_IIJb": "Mejorar en manejo de objeciones",
  "FoodB_0_SMS_yOMB": "Mensajes de texto",
  "Gattaran_0_KP_Tendency_hgOB": "Mejor hora de contacto del representante de la tienda",
  "FoodB_20260130_Lbce_revt": "Conocimiento previo del negocio",
  "FoodC_payment_eCqh_ogxh": "",
  "FoodB_survey_xyMR_sTst": "¿En exclusiva con un competidor? – P",
  "Gattaran_subsidy_tyxq_WwhG": "Agregar recompensa de tarifa de servicio",
  "FoodD_Name_February_bMVM": "Feb",
  "Gattaran_addded_wrMT_Smyq": "Abandonar la promoción",
  "FoodC_202410_Ejdi_makf": "Elige una tienda",
  "FoodB_list_Name_of_dxYm": "Nombre del representante de ventas",
  "Gattaran_REGULAR_UodO_bJVP": "El valor no puede ser mayor a 100",
  "FoodC_202408_Jvou_Cqor": "Lugares cercanos",
  "Gattaran_V1__ZtqD": "Ver tutorial de promociones",
  "soda-c-i18n---送您1张%s优惠券；": "te daremos un cupón de %s;",
  "Gattaran_202406_WOhb_WMrp": "Recibiste una tarea con prioridad alta. Revísala ahora.",
  "FoodB_20250122_aETX_fsRi": "día(s)",
  "FoodB_Contract_QbrO_gJzi": "La recompensa de tarifa de servicio en el acuerdo es {{unit}} {{number}}%",
  "Gattaran_opt_ZoVs_IpEA": "Inicia la firma del contrato, ve el estado de la firma y las razones por las que falló, y mucho más.",
  "FoodOpB_management_Indicators_BzjD": "KPI",
  "Gattaran_visit_CRcg_FwpW": "No",
  "Gattaran_management_wjiE_tOBX": "Hola, {{name}}. Anexo encontraras el resumen de los acuerdos alcanzados en la visita:",
  "FoodB_20250414_zXUI_rXee": "Recompensas de la tienda",
  "FoodD_AccountInfoCollection_Got_it_QvNt": "Entendido",
  "Gattaran_Visit_Formula_pre_iaaI": "Fórmula = (calificación del inicio del día + calificación de la reunión con el cliente + calificación del final del día) / 3 * 100%",
  "FoodB_Dimension_UVvy_UnnT": "Valor promedio de un pedido",
  "Gattaran_Top_pXow_LHcq": "1. Cuando las características “Pedidos completados”, “Tasa de cancelación B” y “Evaluación de los clientes” de una tienda cumplen con ciertos estándares, que varían según la ciudad y se describen en la página Detalles de la tienda, la tienda se identificará como una Tienda DiDi Top.",
  "Gattaran_Optimization_WwkH_amBP": "Ver más personas de contacto y realizar llamadas",
  "FoodC_optimization_GUGp_fDxe": "Volver",
  "FoodB_Launch_DR_Temporary_BQFH": "Permiso residencia temporal",
  "FoodB_0830__BIGT": "Visitas en este mes",
  "FoodB_time_No_permission_Xxyy": "Sin permisos",
  "FoodC_remark_Thank_you_ENoY": "¡Gracias por elegir {{brand_name}}!",
  "FoodOpB_1_Information_gathering_pIHo": "Recopilación de información",
  "FoodB_v108_jDaE_FNvH": "Nombre/ID de la tienda",
  "FoodC_dish_Current_activity_Iyrv": "Esta promoción termina en {{arrived_time}}. Los descuentos para nuevos usuarios ya no estarán disponibles después de esa fecha",
  "FoodB_20250414_uqsI_JhAj": "P1",
  "FoodB_email_mlcn_NvDS": "Método de contacto preferido",
  "soda-c-i18n---晚间：%s-%s": "Durante la noche: %s a %s",
  "FoodB_Validation2_UJDi_eBej": "No se permiten espacios al principio ni al final",
  "FoodB_2_Online_visit_OLuR": "Presencial",
  "Internal_Tools_0510_EoqC_dJrN": "Horario de atención no establecido",
  "FoodC_202410_YFVb_hzJK": "Agrega una dirección",
  "Gattaran_V1__WcTv": "Tasa de productos calificados",
  "FoodB_model20250116_iVfy_zMbV": "Ingreso registrado con éxito",
  "FoodOpB_1_Visit_Details_fMYD": "Detalles de la visita",
  "FoodOpB_results_No_key_kUbv": "No hay contacto de la persona clave",
  "Gattaran_opt_ybdn_zFnD": "Completa la información telefónica faltante",
  "FoodB_0919__flip": "Productos disponibles",
  "FoodB_0617_Blon_MRMe": "Pedidos completados por día - Retiro en tienda",
  "FoodB_audit_Audit_process_asoS": "proceso de revisión. No podrás solicitar una firma hasta que se complete este proceso. ¿Estás seguro de que quieres continuar?",
  "FoodB_20260130_pFZl_PAxD": "A veces",
  "FoodB_calculator_dsiQ_vhFJ": "Monto a recibir",
  "FoodC_202409_dTTH_bjFQ": "Este pedido se ha completado o no existe, por lo que no puede verse.",
  "FoodB_V1_tdXj_tAvG": "Tareas de la tienda",
  "Gattaran_202406_JcEF_NsbI": "Nombre de la tienda",
  "FoodB_1106_qUmr_XNmN": "Error de carga de la grabación",
  "Gattaran_visit_PQZP_gcOK": "Sí",
  "Gattaran_Collection__cRDE": "Búsquedas recientes",
  "FoodC_Website_At_present_XpFw": "En este momento no se puede canjear en la página web. Por favor, canjea el código promocional en la aplicación.",
  "FoodB_202204_Number_of_yYUn": "Pedidos con calificación negativa",
  "Gattaran_0_Add_Image_xyvl": "Aumentar la cobertura de imágenes",
  "Gattaran_MSGCenter__JYjL": "Ingresa",
  "FoodC_edit_bZFb_ghVG": "Encontrarse fuera del edificio del hotel",
  "FoodB_email_KYaO_tHVJ": "Operador de la app",
  "FoodB_Show_Savings_uvSS": "Cuenta de ahorros",
  "Gattaran_opt_aDBh_QgeX": "RTBO",
  "FoodB_Sales_NPeL_QUgG": "Mostrar menos",
  "Gattaran_subsidy_rKRR_cLtu": "Ya existe una recompensa de tarifa de servicio para esta entidad. ¿Deseas reemplazarla?",
  "Gattaran_form_hRvn_xomV": "El número de teléfono es obligatorio",
  "FoodOpB_1_Visiting_hours_yAJS": "Hora de la visita",
  "Gattaran_84_FlDC_sTHq": "Tiempo en línea en otras plataformas:",
  "FoodB_leads_Artificial_labcategory_UNzu": "Categoría de etiqueta manual",
  "FoodD_supplement_Small_time_ycjv": "hora(s)",
  "FoodB_list_Store_ID_GNUR": "No. de identificación de la tienda",
  "Gattaran_0__EDtg": "Habilitar ahora",
  "Gattaran_0_App_Opertends_voML": "Método de contacto preferido del operador de la app",
  "FoodB_system_offline_revV": "Fuera de línea",
  "FoodB_address_Submission_cfyI": "Enviar",
  "FoodOpC_Notifications_Are_you_DIlk": "¿Estás seguro de que deseas eliminar esto?",
  "FoodOpB_manage_Details_IfVh": "Detalles",
  "FoodB_0926__bEjZ": "No hay promociones iniciadas",
  "FoodB_CL_Individuals_VUHt": "Persona física",
  "FoodB_reason_Contact_Courier_Fqog": "Contactar al repartidor",
  "Gattaran_202406_REeT_tgTh": "Tarea",
  "FoodB_20260130_bwfW_jXkh": "Comunicación efectiva",
  "FoodB_list_Brand_Name_pGTc": "Nombre de la marca",
  "Gattaran_transformation__IetC": "Crear nuevo signatario",
  "Gattaran_optimization_dYfW_WtFS": "Finalización",
  "Gattaran_management_LaXK_Gsyq": "Mis visitas",
  "FoodB_1106_LrXH_ibej": "Se está generando tu resumen de IA. Puede demorar entre 1 y 5 minutos. Si cierras esta ventana, el proceso continuará. Una vez que se haya completado, puedes verlo en la Información de seguimiento, en la página Detalles de socio potencial.",
  "FoodOpB_management_Actual_integral_xbDD": "Puntos finales",
  "Gattaran_optimation_Gchd_SmWz": "Omitir",
  "Gattaran_opt_dswD_GkVn": "Visitas",
  "FoodB_v108_QiQv_BLcw": "Nombre de la tienda",
  "Gattaran_Optimization_Gbsd_oiSb": "PK tienda",
  "FoodC_202408_SXSA_LasS": "Agrega tu número de celular para más ventajas",
  "FoodB_0905__qppX": "{{number}} pedidos menos que antes",
  "Gattaran_management_yrfV_Wxnn": "Visita(s) caducada(s) · {{num}}",
  "FoodB_V3_XLPv_RMTE": "Gestionar ahora",
  "FoodD_Name_December_Ykas": "Dic",
  "Gattaran_REGULAR_bTIM_MAXe": "El valor no puede ser mayor a 1000",
  "FoodB_process_xsHa_ISXI": "Rectificada",
  "Gattaran_jumpnewstore_mLmx_PSph": "Completa las tareas de Impulso para tiendas nuevas y consigue más tráfico",
  "Gattaran_0516_bxzD_gtXp": "Tiendas asociadas",
  "FoodB_20260130_HASZ_Gzyp": "Resultados de la visita",
  "FoodD_Compliance_About_to_fTcV": "Caduca pronto",
  "FoodD_Name_June_sECU": "Jun",
  "Gattaran_opt_hEOr_vnKB": "Haz clic aquí para editar la información básica del socio potencial",
  "Internal_Tools_0523_RFQp_wVYb": "Elegible",
  "FoodB_model20250116_dVSj_sFUN": "Revisión pendiente",
  "Gattaran_side__EEqj": "Sábado",
  "Gattaran_Visit_jKcM_bAxG": "Cierre de Acuerdos",
  "Gattaran_url_Myae_HenA": "Enlace al menú {{Uber}} proporcionado por el sistema",
  "Gattaran_0_Name_of_ZnnR": "Nombre del empleado",
  "Gattaran_management_pWnp_hrQt": "Resumen",
  "FoodB_V1_DoLm_HYBb": "Por comenzar",
  "FoodB_V1_FPpu_unON": "Subir el menú físico",
  "Gattaran_20240401_CGBK_NFyI": "Encuesta obligatoria",
  "FoodOpB_Translation_Foreigner_hMcE": "CE-Carnet de Extranjería",
  "Gattaran_0_App_operators_aRSs": "Mejor hora de contacto del operador de la app",
  "FoodB_20260130_SwZo_Vtxu": "Calificación de la etapa: conversación comercial",
  "FoodB_1106_XQNm_orQN": "¿Cuáles son las actualizaciones clave, las necesidades de los usuarios o los problemas esenciales?",
  "帮助中心": "Help Center",
  "Gattaran_optimization_TyQA_JkkG": "Actualizar",
  "FoodB_0919__RZJo": "Pedidos completados",
  "FoodB_Optimization_alYq_lLkr": "Foto de la entrada de la tienda del socio potencial",
  "Gattaran_form_JZlB_BGSo": "Ingresa el motivo",
  "FoodC_web_Only_1_ZddK": "Sólo 1",
  "Gattaran_management_SBaW_IDnY": "Detalles del correo electrónico",
  "soda-c-i18n---将赔付给您%s张免配送费券": "Obtienes %s cupón para un envío gratis",
  "FoodB_process_IUdd_MmbJ": "Apelación exitosa",
  "FoodB_1106_vAhW_qNLK": "Volver a grabar",
  "FoodD_accept_vrSy_OJYX": "Aceptación automática",
  "Gattaran_opt_SrLe_Wnrt": "{{change}} menos que en el último periodo",
  "Gattaran_202311_qwtt_tkJb": "Se muestran las tiendas de la lista de prioridad. Por favor, prioriza estas tiendas para el seguimiento.",
  "Gattaran_management_iAiq_CSuB": "Ya hay una visita planeada para este horario. Edítala e inténtalo de nuevo",
  "FoodD_Name_March_cqIc": "Mar",
  "Gattaran_form_UTaZ_WTAv": "Hay información sin guardar. ¿Estás seguro de que deseas salir?",
  "FoodC_education_2_If_SoSk": "2. Si un inconveniente relacionado con la entrega sucede porque el socio repartidor no siguió las reglas de la plataforma, se podría considerar que fue responsabilidad del socio repartidor.",
  "FoodC_education__unk_aOCD": "Reglas de la aplicación para el tipo de entrega: {{delivery_type}}",
  "Gattaran_Visit_Please_choose_kUmR": "Selecciona a las personas que serán acompañadas",
  "FoodOpB_app_Need_for_inMl": "Reunión adicional ya agendada",
  "FoodB_calculator_UUgW_xBLd": "Cantidad de productos",
  "小费": "Agradecimiento",
  "Gattaran_V1__ccGl": "Últimos 30 días",
  "FoodB_Part1_Store_Name_jrHD": "Nombre de la tienda",
  "sailing.crm-intl.普通": "General",
  "FoodC_education__2_jwSo": "(2) Dejar en la puerta (con nota)",
  "FoodD_page_Manual_Accept_jCTW": "Aceptación manual",
  "FoodB_1106_EwXU_HfGg": "¿Qué trabajo se completó?",
  "FoodB_Show_Subject_Information_RFOj": "Información del Representante Legal/Propietario",
  "Gattaran_0__dPUc": "Se pueden cargar hasta {{amount}} tiendas. Haz clic para ver más",
  "Gattaran_opt2_aPIx_GJQw": "Operativa Plataforma",
  "Gattaran_0_Remind_store_lgTS": "Recordarle a la tienda que se conecte",
  "FoodB_0920__QnBO": "Requisitos no cumplidos",
  "Gattaran_transformation__LRHh": "Asociar signatario existente",
  "Gattaran_opt_XUCE_CQDw": "Editar la información sobre las operaciones fuera de línea",
  "FoodOpB_10_Order_volume_WNmq": "Pedidos",
  "FoodB_resivion_Skip_qpSD": "Omitir",
  "FoodB_model20250116_IADF_eXfa": "Hora de salida",
  "Gattaran_0_Promotional_materials_vvdT": "Materiales de Marketing",
  "FoodOpB_CRM_Card_holder_NfIL": "Número de identificación del beneficiario",
  "FoodB_20250414_qQjO_NTiY": "Línea de tiempo",
  "FoodB_Translation_CHLm_cImn": "Motivo de la apelación",
  "FoodB_email_Lqnd_eyfn": "Acuerdos y comentarios",
  "FoodB_process_URNV_nSAi": "Aprobada",
  "FoodC_202410_SiDC_Empm": "Pedir",
  "FoodB_20260130_hhVl_koul": "Preparación estratégica",
  "FoodB_I_UlHM_KKLT": "Pedidos",
  "FoodC_optimization_RLDn_cLAQ": "Agregar dirección de entrega",
  "FoodB_APP_QiyP_UysU": "ASP",
  "Gattaran_0__sGZg": "No dudes en compartir tus comentarios sobre Explorer con nosotros.",
  "FoodB_Show_Aliens_Residence_creU": "Cédula de Residencia",
  "FoodC_sales_Condition_of_lnwg": "¿Estaba sellado el empaque? (Obligatorio)",
  "Gattaran_Optimization_PLZM_XBgE": "Ver la página de la tienda en DiDi Food",
  "分钟": "min",
  "Gattaran_V1_MQcd_ixfe": "Ver todas las tiendas elegibles",
  "FoodOpB_app_Need_to_eGSb": "Negociando SUP",
  "FoodB_202204_Online_Rate_EQQU": "Tasa de conexión",
  "FoodB_20260130_jmCn_dZjI": "El BD resuelve dudas con empatía, técnica y argumentos concretos. Invita al restaurante a dar el siguiente paso y siempre cierra con un acuerdo claro y concreto que permita avanzar",
  "FoodC_202412_SxTA_sqKU": "Ubicación cercana",
  "Gattaran_REGULAR_luKX_QwKw": "Entrada de impuesto de México",
  "FoodB_0905__ccXH": "Periodo del diagnóstico",
  "FoodC_remark_Enjoy_your_OvmD": "¡Que disfrutes tu comida!",
  "Gattaran_0__XIOS": "Ingresar la cantidad de tiendas",
  "Gattaran_form_zKmF_tGJc": "Confirmar",
  "FoodB_20260130_ZUfZ_dQmW": "Se apoya para dar su discurso en diferentes herramientas, tales como C-app, B-app y Explorer",
  "Gattaran_jumpnewstore_UjqV_XVxm": "Impulso para tiendas nuevas",
  "Gattaran_202311_NpGG_CLsO": "Mostrar resultados a una distancia máxima de {{distance}} de la tienda",
  "FoodC_reasons_Enter_a_Pnzg": "Por favor, describe los detalles del problema.",
  "FoodB_V1_Yqgj_TuBe": "Vencido",
  "Gattaran_optimation_shNo_Pflo": "Abandonaste inesperadamente la página Formulario de visita. Toca “Volver a abrir” para volver a la última página en la que estabas.",
  "FoodB_calculator_hmWL_DEwB": "No",
  "FoodC_20240607_IbZr_cIyA": "Por favor, revisa el enlace de la tienda y vuelve a intentarlo",
  "FoodB_0617_Bibj_VmDq": "Plataformas de la competencia",
  "Gattaran_function__Comd": "Notas de la publicación",
  "FoodB_Upload_qSTm_LkAc": "Menú físico",
  "FoodC_education__4_QYXm": "(4) Te negaste a pagar un pedido con pago en efectivo",
  "FoodB_V2_No_bank_plEI": "Faltan los datos bancarios",
  "FoodB_Show_Final_Tax_XQQi": "Definitivo",
  "FoodC_education__3_ltNM": "(3) Otros factores que no puedes controlar y que causaron que se haya cancelado el pedido, como que no se haya podido encontrar un socio repartidor que entregue el pedido o algún otro problema relacionado con la plataforma.",
  "FoodB_model20250116_QHad_xAWm": "Tipo de visita",
  "FoodB_20260130_pTZf_mCnP": "Rara vez",
  "Gattaran_jumpnewstore_WVcO_LmBU": "Ver detalles",
  "Gattaran_add_XrAW_datb": "Productos disponibles >= 5",
  "FoodB_up20241218_ZADd_MrpU": "Por favor, selecciona entre uno y cinco productos. No pueden seleccionarse productos o bebidas con alcohol.",
  "Gattaran_management_DvoF_BCCh": "Tareas de visitas",
  "FoodOpB_CRM_Type_of_fbmW": "Tipo de identificación del beneficiario",
  "FoodB_Contract_YYIE_YBzS": "Sí",
  "Gattaran_Collection__YHYF": "Recomendado",
  "FoodB_V2_Failure_to_sQaD": "No cumple con los requisitos",
  "FoodC_edit_fOqC_upyr": "Encontrarse en la recepción",
  "FoodOpB_management_Indicator_description_kePF": "Descripción de KPI",
  "FoodB_20250612_vHLr_wHDi": "Número de WhatsApp",
  "FoodB_Show_Tax_payment_Dbuz": "Forma de pago de impuestos (Local)",
  "Gattaran_transformation__PgJQ": "Información del Representante Legal/Propietario",
  "FoodC_202410_KMCG_kJBn": "Cambiar",
  "FoodB_calculator_pQIn_LdhF": "¿El RFC es válido?",
  "FoodOpB_Translation_BD_with_Jqpl": "Foto del representante de ventas en la entrada de la tienda",
  "Gattaran_20240902_AmRI_DoWJ": "Motivo del rechazo",
  "FoodC_all_No_reward_ocGJ": "Sin recompensas",
  "FoodB_0622_Contrast_jVys": "Comparar",
  "FoodOpB_Translation_Enter_CCI_YyDK": "Ingresar cuenta CCI",
  "FoodOpB_CRM_Taxpayer_full_tMpR": "Nombre completo del contribuyente (local)",
  "FoodB_communications_BCnM_evHy": "tiendas que tienen acciones a realizar esta semana para el impulso de tiendas nuevas",
  "Gattaran_v1_HLQw_cJDz": "Toca para mostrar los detalles sobre el horario de operación de la tienda",
  "FoodB_supplement_No_data_jUGB": "Sin datos",
  "Gattaran_limit_NvlC_czdh": "Sólo el asesor de la tienda puede realizar esta acción",
  "FoodB_Contract_fYLE_mfir": "Actualizar información de encuesta para la tienda",
  "soda-c-i18n---联系商家": "Contactar a la tienda",
  "Gattaran_transformation__pglh": "Guardar y volver",
  "Gattaran_management_dWbz_DrVf": "Visitas presenciales completadas · {{month}}",
  "FoodOpB_management_Weight_sGBg": "Peso",
  "FoodB_V1_pmrO_ZtzK": "Completado",
  "FoodC_edit_cKhP_xcTQ": "Encontrarse en la puerta de mi vivienda",
  "FoodC_202410_FxEp_LCxL": "Procesando pago",
  "FoodOpB_CO_Provisional_Tax_ZpCx": "Provisional",
  "FoodC_edit_DOXu_EYnd": "Ejemplo: “llamar a la puerta, no tocar el timbre.” También puedes subir fotos de los alrededores para ayudar al repartidor a entregar tu pedido en el lugar correcto.",
  "FoodB_process_HvCv_QDks": "A rectificar",
  "Gattaran_V1__SttS": "Promociones",
  "Gattaran_V1_qsGI_Ulsk": "Cargando datos, aguarda un momento",
  "Gattaran_schedule_ajzu_twuj": "Se alcanzó el límite",
  "FoodB_0926__pZyK": "No hay promociones en curso",
  "FoodB_Show_ID_Card_BrxO": "Cédula de Identidad",
  "FoodB_030_zOTR_tsWu": "Mi zona",
  "FoodB_1106_tybs_uREn": "Error de carga del archivo de audio",
  "Gattaran_withdraw_Ofwd_NgCY": "Una vez cancelado, este proceso de solicitud finalizará, y cualquier solicitud de firma posterior deberá enviarse de nuevo. Procede con cuidado.",
  "Gattaran_merchantfee_Pqxr_WLCJ": "El valor ingresado no puede ser mayor de {{max}}",
  "Gattaran_V1_YDbp_akEe": "Todas las promociones válidas",
  "FoodB_0617_BYzk_fNiR": "Hay un contrato de exclusividad con la competencia - R",
  "FoodB_202311_VkTS_OoIy": "Vencida",
  "FoodB_survey_eOXC_QSNG": "Demanda de crédito revolvente",
  "FoodD_payout_Company_Registration_zoVW": "Cédula Jurídica",
  "FoodOpB_1_Visiting_Status_rbMX": "Estado de la visita",
  "FoodB_audit_Distance_between_BRSw": "Distancia entre la tienda anterior y la nueva",
  "FoodD_2_Income_Vqfp": "Ganancias",
  "FoodB_record_HWEd_dEzy": "Todo",
  "FoodC_notice_fOyQ_lqIn": "El pago en efectivo no está disponible. Por favor, revisa si el importe del pedido supera el límite, o si tienes otro pedido con pago en efectivo en curso, e inténtalo de nuevo más tarde.",
  "FoodB_Launch_DR_Foreigner_gXpW": "Cédula Extranjera",
  "FoodB_0617_bADA_vnGU": "Servicio de pedidos autogestionados",
  "Gattaran_0__uLBv": "Ingresar la cantidad de pedidos",
  "FoodB_210811_No_tax_QkcN": "Falta un documento fiscal",
  "Gattaran_V11_fscy_YDKX": "Requisitos",
  "FoodC_20240607_wfRH_rTAa": "Información de la tienda",
  "Gattaran_form_rnAn_flyZ": "Se debe(n) ingresar el número de teléfono o foto(s) del representante de la tienda",
  "FoodB_collection_Taxpayer_Postal_guUo": "Código postal del contribuyente",
  "FoodB_1106_foqL_RTHY": "Describe el siguiente contenido grabando con la voz, subiendo audio o ingresando texto:",
  "FoodC_202412_nXPk_kwtQ": "¿No encuentras la dirección? Prueba otras palabras",
  "Gattaran_20240401_LMVL_IKxX": "Salir de la aplicación",
  "FoodB_1106_AyGO_yZLr": "Asegúrate de que tu conexión de red es estable y toca \"Analizar de nuevo\". Volveremos a generar el resumen de IA.",
  "FoodB_management_Business_hours_VLnY": "Horario regular de operación",
  "FoodC_edit_hDGv_arOT": "Encontrarse en la recepción de abajo",
  "Gattaran_Visit_Personal_Goals_FDcw": "Objetivo personal / Aprendizaje",
  "Gattaran_mgt_Search_Results_pFNV": "Resultados de búsqueda",
  "FoodB_420241024_mWia_Agjc": "No se logró",
  "FoodC_education__1_mJTG": "(1) Si la tienda ya confirmó y aceptó el pedido, puedes usar la función \"Cancelar pedido\" o contactar a la tienda y pedirle que cancele el pedido. Si la tienda no acepta cancelar el pedido porque ya está listo o por otro motivo razonable, no podrás cancelar el pedido sin costo alguno. Si insistes en cancelar o te niegas a aceptar una parte del pedido o el pedido completo, se considerará tu responsabilidad y deberás pagar el precio total correspondiente a ese pedido.",
  "Gattaran_mgt_Indicates_that_nHWP": "Indica “No logrado”",
  "FoodB_APP_jedo_DJtn": "Situación de la promoción",
  "Gattaran_V1__hUDQ": "Servicio",
  "FoodB_0_Please_upload_BZIQ": "Carga una captura de pantalla del historial de chat",
  "FoodB_Show_Current_NJqK": "Cuenta corriente",
  "Gattaran_0_Clerk_nZnx": "Empleado",
  "FoodB_CL_power_of_KgHH": "Carta Poder",
  "FoodC_edit_iuIV_BOva": "10 minutos",
  "Gattaran_mgt_Sort_QiOq": "Ordenar",
  "FoodB_list_KP_Phone_qQCQ": "Teléfono del representante de la tienda",
  "Gattaran_AlertV1_CYCs_NjzG": "Haz clic aquí para ver las tiendas que requieren tu atención",
  "FoodB_Contract_wsvf_fSJn": "Comparación con precios para comer en el lugar en el acuerdo",
  "Gattaran_jumpnewstore_lspf_nNoN": "Toca para abrir el módulo Impulso para tiendas nuevas y ver los detalles relevantes para que la tienda complete las tareas correspondientes",
  "FoodB_V2_dLkl_pbiF": "Para realizar esta acción, actualiza a la versión más reciente de la app",
  "FoodB_1106_QRoy_iWHx": "Iniciar grabación",
  "FoodB_model20250116_innF_fIuu": "Visita exitosa",
  "FoodB_management_Store_association_coYB": "Afiliación de la tienda",
  "FoodC_202408_ksyj_sXlp": "Acerca de la tienda",
  "Gattaran_store_ylep_UGpm": "Finaliza la firma del contrato a través del portal oficial",
  "FoodC_202412_dCuL_VUFU": "Actual.",
  "Gattaran_0_Are_there_ouHJ": "Tiene más restaurantes",
  "FoodC_202412_bolI_YXBT": "Direcciones guardadas",
  "FoodB_B86_Bhsy_ekdS": "Gestión de irregularidades",
  "FoodD_Storefront_YFcS_cnUy": "DiDi Negocio",
  "FoodC_202412_Oant_EESB": "Siguiente",
  "Gattaran_0_Edit_contacts_nCLZ": "Editar persona de contacto",
  "Gattaran_function__fALF": "Cancelar",
  "FoodB_method_hwZM_aUnb": "Descargar Explorer",
  "Gattaran_Feedback__urHD": "Bajo",
  "FoodB_management_Automatic_closing_xRSd": "Cierre automático de la tienda",
  "Gattaran_opt2_UTsL_QVlH": "Otros",
  "Gattaran_Visit_Total_score_iZIW": "Puntación total",
  "Gattaran_202406_xlNL_HNSV": "Recomendamos cargar la información sobre el tipo de archivo en la página GTR > Gestión de tareas de ventas",
  "FoodC_202408_RRtT_ZjIG": "Agregar dirección de entrega",
  "FoodC_20240607_hhNB_mCBD": "Número de celular",
  "FoodB_email_QTTk_ZllR": "Enviar acuerdos a la marca",
  "FoodB_V1_raHO_jXSF": "Tasa de gastos/GMV este mes",
  "FoodB_20231012_GZve_uPZM": "Ya se establecieron las reglas de cálculo de la fecha límite para este tipo de tarea. Por favor, no vuelvas a ingresarlas.",
  "FoodB_diagnosis_Items_qQOR": "producto(s)",
  "FoodB_field_No_need_hToz": "Opcional",
  "FoodB_2__YqWB": "Motivo del rechazo",
  "FoodB_APP_rwZD_SFlh": "B2C + P2C burn / GMV",
  "FoodC_edit_Fyzp_tERt": "El repartidor te contactará cuando llegue y esperará en el lugar acordado por {{time}}. Por favor, ten tu teléfono a la mano.",
  "FoodOpB_Translation_Passport_jpaq": "Pasaporte",
  "Gattaran_Visit_Pre_visit_NLpf": "Calificación del inicio del día.",
  "FoodB_requirement_uBiP_YocR": "Porcentaje de pedidos no preparados a tiempo",
  "Gattaran_Visit_Tracking_KfAS": "Seguimiento",
  "FoodB_calculator_CcKA_weRh": "Para propósitos referenciales únicamente: el pago final a las tiendas estará sujeto a deducciones por cancelaciones, temas de posventa y otros motivos.",
  "FoodC_202408_qGSr_IQoW": "Editar",
  "FoodB_APP_mDID_tHft": "Seleccionar periodo de datos",
  "FoodB_incomplete_hmSA_mNRv": "Marcar como No completado",
  "Gattaran_add_MyGp_GdUb": "avatar",
  "FoodOpB_1_Visit_today_hLhX": "Hoy",
  "FoodB_20260130_BVCG_uZQW": "Fórmula = (Puntaje del evento 1 / 5 + Puntaje del evento 2 / 5 +…) / Cantidad de eventos válidos * 100%",
  "soda-c-i18n---提交申请": "Solicitar cancelación",
  "Gattaran_function__PRSL": "Descargar",
  "Gattaran_0_Consistent_with_CiFN": "Tenerlos igual al menú",
  "FoodOpB_v2_Type_BpqS": "Tipo",
  "FoodB_1106_zLsQ_PVUN": "Método de seguimiento",
  "FoodB_1106_UWHB_lYiW": "Transcripción de grabación",
  "FoodB_1106_oEsa_BYuK": "¿Cuáles son los próximos pasos?",
  "FoodC_202408_cjXm_VVcd": "Si sales, no podrás ver tu pedido",
  "Gattaran_0_Buy_gifts_dbKh": "2x1, 3x2, 4x3, 5x4",
  "Gattaran_statusbar2_QzkZ_tHWY": "Borrador",
  "Gattaran_0_No_match_Tgve": "Envío gratis",
  "Gattaran_visit_nNId_fOhX": "La visita del BD fue efectiva",
  "Gattaran_REGULAR_irYR_Bntt": "Si no estás seguro de si tu RFC es válido, cópialo y compruébalo en el sitio web oficial que se indica a continuación:",
  "Gattaran_opt_ikuS_aRyl": "Result. visita",
  "FoodB_Contract_tvcI_RNvn": "Se cargó correctamente el menú para consumo en el lugar aprobado",
  "FoodC_revision_Less_meal_pHwq": "Error en pedido",
  "FoodB_task_HEvc_Emme": "Se ejecutó/ejecutaron {{X}} tarea(s) durante esta visita",
  "Gattaran_Visit_Rating_after_lruO": "Calificación del final del día",
  "FoodB_1106_uIrJ_FVVL": "¿Cuáles son las actualizaciones clave, las necesidades de los usuarios o los problemas esenciales?",
  "FoodB_communications_UOIk_QdZg": "Realiza las acciones para el impulso de tiendas nuevas para obtener ventajas adicionales. Las acciones vencen en {{task_left_days}} día(s)",
  "FoodOpB_Translation_Please_add_mxTD": "Carga uno de los siguientes documentos: Poder del Representante Legal, Certificado de Comercio de Registro de la ciudad respectiva, Certificado de Estatuto Actualizado.",
  "FoodB_process_hZyR_OxLH": "Copiar enlace de la tienda {{name}}",
  "FoodB_Fields_CnCd_RzYS": "En revisión",
  "FoodC_method_Wait_keAM": "Esperar",
  "FoodOpB_management_Corresponding_fractions_QlGf": "Puntos",
  "FoodB_CL_Simple_company_JBRG": "Sociedad de sistema simplificado",
  "FoodC_edit_bxpb_udFq": "Ejemplo:  Av. Paseo de la Reforma 301, Edificio C, Núm. interior 21, Cuauhtémoc, 06500, Ciudad de México",
  "FoodB_IV_Open_shop_xlhI": "Apertura automática de la tienda",
  "Gattaran_visit_xnVQ_bENu": "Objetivos a mejorar",
  "Gattaran_0_Package_fweo": "Combos",
  "FoodB_20260130_VCAk_tRtc": "Mejorar la preparación y estrategia de visita",
  "FoodB_1106_eUGB_DZjs": "Actualizaciones clave",
  "FoodB_1106_oWun_aWqC": "No hay actualizaciones claves en este momento",
  "Gattaran_Visit_After_a_ILbF": "Final del día",
  "Gattaran_20240902_ahLx_jQSe": "La tarea {{tasktype}} que creaste para {{shopname}} se rechazó. Por favor, completa la información de referencia de la tarea según el motivo del rechazo.",
  "FoodB_0622_Store_management_ztNB": "Operaciones de la tienda",
  "FoodB_20250612_WpCB_xKZJ": "Otros",
  "FoodB_202402_TFYh_dasm": "Otros",
  "Gattaran_202406_SQiw_AXZW": "Gestión de tareas de ventas",
  "Gattaran_tag_mnOh_LlIQ": "Promoción vencerá",
  "Gattaran_V1__zewR": "Menú",
  "Gattaran_store_HrLF_aQuF": "Inducción",
  "Gattaran_Collection__twwL": "Puedes ver el registro de visitas completo aquí",
  "FoodB_1106_grLB_GkRM": "Si cierras la página durante la carga, no se guardará el resultado actual.",
  "FoodC_202408_tlOV_uOmJ": "Agrega tu número de celular y obtén promociones en tus pedidos",
  "FoodB_communications_hhCR_kEAh": "tiendas que tienen acciones a realizar esta semana",
  "Gattaran_V11_DQdi_QRqK": "No logrado",
  "Gattaran_mgt_Performance_data_ymwM": "Datos de rendimiento",
  "FoodB_field_Needs_IbzB": "Obligatorio",
  "FoodB_1106_ACTr_mhVt": "Confirmar",
  "Gattaran_0_Visit_Information_hzgb": "Información de las visitas",
  "Gattaran_opt_KdGX_oUmM": "Firmar",
  "FoodB_survey_yEPf_ujZP": "Pedidos completados por día con la competencia - P",
  "FoodB_executors20241225_bYiY_UfOD": "Lógica de asignación automática",
  "Gattaran_center__TkvV": "Sin mensajes",
  "soda-b-homepage-i18n---首位必须是1，必须输入11位": "El primer dígito debe ser 1 y se deben ingresar 11 dígitos.",
  "Gattaran_Visit_APP_Review_nbGn": "Revisión de la app",
  "FoodOpB_Org_Add_at_nQez": "Se debe agregar al menos un KPI. Revísalo y vuelve a intentarlo.",
  "FoodB_comparison_dRXO_qebt": "Ajustar precio",
  "Gattaran_form_nFaJ_bcHw": "Persona de contacto",
  "FoodB_1106_jqDc_LmDv": "No se pudo cargar la grabación. Por favor, asegúrate de que tu red sea estable e intenta grabar de nuevo.",
  "Groceries_1_MhVY_Etfm": "Producto cambiado",
  "FoodB_collection_Enter_idCIF_NeUD": "Ingresar idCIF",
  "FoodB_process_jvuI_tPXa": "Elegir producto principal",
  "Gattaran_side__sOcs": "Martes",
  "Gattaran_REGULAR_OPsx_JMnf": "Calcular",
  "FoodB_up20241218_VRuL_OZqJ": "Registro previo de la promo",
  "FoodB_audit_The_strings_NPFx": "Hacer clic en confirmar iniciará el proceso de revisión \"{{strings}}\". No se puede solicitar la firma del contrato hasta completada la revisión. ¿Deseas continuar?",
  "Gattaran_Mode_DJzU_JeyE": "Modo comercial",
  "FoodC_1_dXUH_ThDd": "Ver más",
  "Gattaran_Visit_View_Visit_eZdF": "Ver planes de visitas",
  "FoodB_20260130_Czox_PUeI": "Manejo de objeciones y comunicación",
  "FoodB_ads_yERH_XMYy": "¿Se ha registrado correctamente el anuncio promocional?",
  "Gattaran_v1_guwq_yflY": "Toca para ver los detalles del evento de promoción",
  "FoodB_governance_ireV_yxHO": "Fecha límite de la tarea",
  "FoodC_edit_oOAR_FExH": "Oficinas",
  "FoodC_202412_MrwA_fRUi": "En este momento, la tienda está cerrada. Por favor, regresa más tarde.",
  "FoodB_0707_Lifted_off_tnXl": "No disponible",
  "Gattaran_ProgressManagement_ArNE_PsZi": "Persona responsable",
  "FoodB_email_qdfP_heFs": "¡Hola! Visitamos tu tienda {{store_name}} y revisamos lo siguiente junto con {{person_to_be_visited}}:",
  "FoodB_0113_ZcCF_NbjE": "Puedes agregar un plan de visita aquí",
  "Gattaran_0__VQyB": "Mis tiendas",
  "FoodB_Show_Special_residence_ezfV": "Permiso Especial de Permanencia",
  "FoodC_202408_ajMC_lsta": "Tienda cerrada",
  "FoodB_audit_Review_Opportunity_ZQHk": "Revisión de la información básica del socio potencial editada",
  "FoodB_Contract_ZLgE_qHzf": "Comparación con precios del competidor en el acuerdo",
  "FoodC_202408_RTrU_hOhN": "Por favor, activa los permisos de ubicación. Para hacerlo, ve a la configuración del sistema, selecciona la aplicación y activa los permisos de ubicación correspondientes.",
  "FoodB_audit_Click_OK_Zfsf": "Si das en confirmar, se activará el",
  "FoodB_time_All_day_TIsU": "Cerrada todo el día",
  "FoodC_page__iyoe": "Ver menos",
  "FoodB_1106_PVUq_gUVg": "Entrada de voz",
  "soda-c-i18n---将赔付给您1张%s折扣券": "Obtienes un cupón del %s de descuento",
  "FoodB_0622_Sales_KRCg": "Volumen de ventas",
  "FoodB_0617_lXTk_DfVL": "Fecha de vencimiento del contrato de exclusividad con la competencia - R",
  "FoodB_20250612_nsLy_sirO": "Debes ingresar entre ocho y nueve dígitos",
  "Gattaran_opt_JcLo_plhe": "Horas en línea",
  "FoodOpB_1_Fill_in_QvuH": "Crear plan de visita",
  "FoodB_subsidy_xslH_mDaQ": "Este Acuerdo complementario para la recompensa de tarifa de servicio se firmará bajo el nombre de esta tienda. Actualmente, hay varias tiendas que ya han firmado bajo este nombre y que también recibirán recompensas de tarifa de servicio adicionales. ¿Quieres continuar con la firma?",
  "Gattaran_0_Increase_in_yvaq": "Aumentar el horario de operación",
  "Gattaran_202406_wmja_Unkw": "Ejecutor de la tarea",
  "FoodC_202412_PwIG_QPFY": "Ingresa una dirección",
  "Gattaran_84_Khbi_virb": "Fecha y hora de detección de la plataforma",
  "Gattaran_opt_jfHC_vGTC": "Mes en curso Orden",
  "FoodB_Tax_nKEQ_EIAC": "Monto de ISR de la empresa",
  "FoodB_20260130_TlfO_izWQ": "Realiza preguntas abiertas para conocer la actualidad del restaurante, escuchando e identificando sus necesidades",
  "FoodC_202408_PJcq_SjqG": "¡Ups! No hay información de contacto para esta tienda",
  "FoodB_20260130_XEUl_vhGH": "Gestión del tiempo",
  "FoodB_0322_gUpY_CIHG": "No hay tiendas que coincidan con los filtros",
  "FoodB_list_Apply_for_RxQn": "Solicitar firma",
  "FoodB_field_Is_you_uNye": "¿Sujeto al pago del IVA nacional?",
  "soda-c-i18n---延迟送达%s分钟以上": "Demora mayor a %s minutos",
  "Gattaran_invalid_Itxj_ruEf": "Se eliminaron los socios potenciales no válidos. Para encontrarlos, por favor, aplica un filtro o usa la función de búsqueda.",
  "Gattaran_0_Using_Store_khfo": "Usa la app en",
  "FoodB_calculator_hPAw_BZlP": "Impuesto cedular",
  "Gattaran_202406_rpdn_vXVr": "Observaciones",
  "FoodB_process_tlsV_pFnp": "Confirmar coincidencia",
  "FoodC_homepage_Search_for_CiMZ": "Buscar comida",
  "FoodB_model20250116_wlQy_yyEp": "Hora de la visita",
  "Gattaran_0_Full_gift_nhuV": "Gasta X, obtén Y",
  "FoodB_b_Source_of_qGPd": "Origen de la promoción",
  "FoodB_0_Please_upload_roTo": "Carga una captura de pantalla del historial de correo electrónico",
  "FoodB_governance_Kygz_iFAW": "Rectificación por comparación de precios para comer en el local completada o no",
  "FoodB_email_NJBQ_LwUX": "Este contacto no tiene un correo electrónico registrado, por lo que no se le pueden enviar este tipo de mensajes. Por favor, agrega un correo electrónico y vuelve a seleccionarlo.",
  "Gattaran_0_App_Operator_HJuu": "Número del operador de la app",
  "FoodB_202202_Minutes_tWiN": "min",
  "FoodB_calculator_WFgZ_JmvX": "Calculadora de pagos",
  "FoodC_education_Principles_of_RKEk": "Reglas en caso de algún inconveniente con la entrega",
  "Gattaran_mgt_Search_History_DIkw": "Historial de búsqueda",
  "Gattaran_center__IJmL": "Mensajes",
  "Gattaran_schedule_eLPM_Vdmp": "Continuar",
  "Gattaran_visit_Zykg_WdpB": "El BD preparó la visita",
  "FoodB_20260130_Fokt_VXiq": "Enfoque a los resultados y proactividad",
  "FoodB_up20241218_WbCj_pCMp": "Registro previo para la promoción de productos en promoción de tienda nueva",
  "Gattaran_form_HAwV_aOvm": "Resultado de la visita",
  "FoodB_0617_tikP_Dusl": "Encuesta para la tienda",
  "FoodB_process_PFDy_CuVh": "En revisión",
  "FoodB_20250612_ehqr_pgKz": "Gerente de tienda",
  "FoodOpB_Translation_General_accounts_NeVu": "Cuenta de ahorros",
  "FoodC_MVP_ASpO_MFfF": "Detalles del pedido",
  "FoodB_Translation_mIfp_fymE": "Resolver",
  "Gattaran_side__EgXn": "Lunes",
  "FoodC_details_Refund_Details_sGIk": "Detalles del reembolso",
  "FoodB_250430_GwJd_SQQB": "Nivel de la tienda",
  "FoodB_Translation_IfKE_iqmc": "Rectificación fallida",
  "FoodOpB_CRM_Taxpayer_Address_ptqR": "Dirección del contribuyente (local)",
  "Gattaran_Visit_Management_and_JkoC": "Administración y próximos pasos",
  "Gattaran_Visit_Select_a_YAtw": "Selecciona una fecha para la visita con acompañantes",
  "Gattaran_center__vsus": "Haz clic para ver los detalles",
  "FoodB_APP_wyiJ_mGlw": "Mes de inicio",
  "FoodB_20250414_faym_bhsa": "Coinversión de la plataforma",
  "Gattaran_management_cYvq_XraB": "No hay información de las visitas",
  "Gattaran_transformation__njrW": "Nombre del firmante",
  "Gattaran_Visit_New_escort_zHov": "Crear visita con acompañantes",
  "FoodB_calculator_tLev_cAgO": "Pago en línea",
  "Gattaran_uikey_qCBF_mlck": "Commercial Offering",
  "FoodB_new1_Name_similarity_gepH": "Similitud del nombre",
  "Gattaran_V1_JVoT_DmFC": "Ver",
  "Gattaran_opt_qiBN_MCGQ": "Revocación",
  "Gattaran_202311_xiHr_yFIi": "Recomendadas",
  "FoodB_20260130_WkaF_rdke": "Si la puntuación de un módulo es “Sin calificación”, entonces dicho módulo no se incluye en la calificación total",
  "Gattaran_optimization_Tore_pnsp": "Parece que tu ubicación ha cambiado. ¿Deseas actualizar esta página?",
  "Gattaran_form_hGfR_KtSN": "Agregar resultado de la visita",
  "Gattaran_management_gqoK_XBEn": "Hoy",
  "FoodB_20260130_eosk_tYnU": "Visitas efectivas {{effective_visit_percentage}}, visitas no efectivas {{ineffective_visit_percentage}}",
  "FoodC_202408_sbmp_YFyl": "Ubicación actual",
  "Gattaran_202406_TbgT_vOga": "¿Confirmas que deseas enviar? Una vez hecho el envío, no se podrán hacer cambios.",
  "FoodB_Optimization_xyJu_XgOc": "Por favor, ingresa 10 dígitos",
  "Gattaran_20240902_KYYY_BwXS": "Por favor, describe el motivo del rechazo de la tarea",
  "Gattaran_V1_IUgS_cyMV": "tienda(s) puede(n) registrarse",
  "FoodD_problem_I_see_NhGG": "Aceptar",
  "FoodB_optimization_Contract_No_GvBj": "Núm. de ident. del contrato",
  "FoodB_list_Online_Inspection_rExT": "Inspección de la tienda",
  "FoodB_20250122_WEun_Whes": "Requisito previo para la asignación de tareas",
  "Gattaran_202406_lKot_vsVa": "Descargar archivo del sistema GTR > Módulo de gestión de tareas de ventas",
  "Gattaran_function__DqfF": "Actualización de versión",
  "FoodB_switch_yJQj_DSir": "Participando en promociones 100% financiadas",
  "Groceries_brand_bqwY_mhhq": "Creado correctamente",
  "FoodC_sales_Supplementary_information_ihyk": "Detalles adicionales",
  "FoodB_2_Planned_bPON": "En planificación",
  "FoodB_1106_jWEH_dYMs": "Volver a analizar",
  "FoodB_Wordings_iyFv_fDmW": "Observaciones adicionales",
  "FoodC_education_In_the_nIgD": "La cancelación se considerará responsabilidad tuya en las siguientes situaciones:",
  "Gattaran_schedule_yPeR_CtMc": "Hay más de {{number}} planes de visita presencial para el día seleccionado. Los primeros {{number}} planes de visita se seleccionarán automáticamente para generar una ruta para ti.",
  "FoodC_202412_SJdc_Bwta": "¿No es una ubicación cercana? Toca el botón de la derecha para actualizar tu ubicación.",
  "FoodC_dish_New_guest_bkGC": "Para primer pedido",
  "FoodC_202408_WiRK_SITI": "Agregar dirección",
  "FoodB_GTR_rBBn_RmKL": "Estándar",
  "FoodOpB_Home_Mandate_vafk": "Tareas",
  "FoodC_education__2_KHhl": "(2) Si no llegaste al lugar de la entrega a la hora especificada o si ingresaste la dirección o número de teléfono incorrectos, te negaste a aceptar una llamada del socio repartidor o te negaste a recibir parte del pedido o el pedido completo sin un motivo justificado, deberás pagar el pedido.",
  "FoodB_management_Queries_dawh": "Buscar",
  "FoodB_calculator_giVW_AULQ": "Precio unitario de la plataforma",
  "FoodC_education_If_you_RTIV": "Si pagaste un pedido y necesitas cancelarlo, se aplicará lo siguiente:",
  "FoodB_1106_xaYu_lPMa": "Seguimiento rápido",
  "FoodB_calculator_EeIc_TwiG": "Persona moral",
  "FoodB_optimization_Stimulate_contact_xSSH": "Método de contacto preferido",
  "Gattaran_20240918supplement_ISmP_qTmN": "Editar tarea",
  "FoodB_B86_Kypx_nBHu": "Notas",
  "FoodB_0919__mVqa": "Demoras en la entrega",
  "FoodC_receive__UdqW": "día(s)",
  "FoodB_420241024_FldG_feZL": "Valor objetivo",
  "Gattaran_202406_NcUB_dVhS": "Hora de creación de la tarea",
  "FoodOpB_center_Action_MexV": "Acciones",
  "FoodB_Contract_tFOZ_SiQZ": "¿Promo registrado?",
  "FoodB_Analysis_Decline_gSax": "Disminución:",
  "Gattaran_opt2_egxV_xfoW": "Imperfecto Orden%",
  "Gattaran_mgt_Display_content_IlcO": "Mostrar contenido",
  "Gattaran_0__BHKX": "Mapa",
  "Gattaran_tools_IbIT_QTXz": "Ingresa un número de teléfono válido",
  "Gattaran_management_IDJi_lZyx": "{{amount}} visita(s) programadas para hoy. Revísalas",
  "FoodB_Show_Company_Registration_VcVV": "Cédula Jurídica",
  "FoodB_Contract_BRLH_nPAs": "¿Primera conexión completada?",
  "FoodB_0617_Cgpc_KwbS": "Por favor, ingresa un valor con dos decimales",
  "FoodB_Contract_ywoA_Ojgz": "No",
  "FoodB_model2025011603_ztWt_rarX": "Por favor, selecciona primero el método de visita y el tipo de visita",
  "FoodC_202408_cktm_HTVV": "Entendido",
  "FoodOpB_OpsTasks_Off_GCPV": "Cerrar",
  "Gattaran_mgt_Gap_BnAE": "Gap",
  "Gattaran_20230803_WsGI_IIwM": "Objetivo",
  "Gattaran_20240401_LxEe_Ydha": "Encuesta",
  "Gattaran_0__tYzF": "No hay más tiendas en el área actual. Arrastra el mapa para cargar más",
  "Gattaran_84_xcpB_yRxH": "Identificación del firmante",
  "FoodB_20250414_BqXP_FPkP": "Tasa de recompra",
  "Gattaran_Visit_Objection_management_WIuV": "Manejo de objeciones",
  "优惠券": "Cupón",
  "FoodB_250430_YTkG_lNTj": "Nivel de la marca",
  "FoodC_optimization_hksX_yevn": "Agrega la dirección donde se entregará tu pedido.",
  "FoodOpC_jiatalan_Deleted_successfully_GeGq": "Eliminado correctamente",
  "FoodB_1106_XZeN_ahHQ": "Una vez que hayas terminado de ingresar el contenido, se generará automáticamente un resumen mediante IA.",
  "FoodB_calculator_cctL_sltb": "Total del pedido",
  "soda-c-i18n---订单实际送达时间晚于预计送达时间%s分钟以上、%s分钟以下，": "Si tu pedido llega entre %s y %s minutos después del tiempo de entrega estimado, ",
  "FoodB_collection_5_6_hFrc": "Debe contener 5 o 6 dígitos sin espacio",
  "Gattaran_opt_lDge_zZTn": "Haz clic aquí para usar la navegación por mapa; haz clic en el ícono de teléfono para obtener la información de contacto de KP y la tienda",
  "Gattaran_management_icdH_hGfu": "Detalles",
  "Gattaran_0_Training_DM_ozrH": "Entrenar al DM o al operador de la BApp",
  "FoodB_email_WcaT_rLqN": "El resultado de la visita está incompleto. Por favor, ingresa el resultado de la visita antes de continuar con la optimización.",
  "FoodB_communications_udno_SENU": "Hay una o más promociones pendientes de aceptación. Participar en las promociones podría ayudar a impulsar las ventas.",
  "Gattaran_0_Maximum_number_pgYM": "Puede crearse hasta una persona por cada rol",
  "FoodB_CL_Letter_of_EmKs": "Foto de la Carta Poder",
  "FoodB_0113_ELbg_zfBg": "Ver info. sobre el asesor de la tienda aquí",
  "FoodB_Analysis_Old_people_fwCy": "Usuarios recurrentes",
  "Gattaran_0__iUtr": "Correo electrónico",
  "FoodOpB_Translation_Natural_persons_fVFa": "Persona física",
  "FoodB_0905__wwdP": "Peso de subproducto",
  "FoodC_edit_ldOR_SyHv": "Ejemplo: “llevo una camisa estampada y estoy esperando en la calle.” También puedes subir fotos de los alrededores para ayudar al repartidor a entregar tu pedido en el lugar correcto.",
  "FoodC_improve__ByLg": "Diferente a lo esperado",
  "FoodOpB_Tool_Set_FrCO": "No configurado",
  "Gattaran_v1_fltf_eBMP": "Registrado. Consulta los detalles en la app de DiDi Tienda.",
  "Gattaran_0_Purpose_of_COzp": "Objetivo de la visita",
  "soda-c-i18n---超时赔付规则说明": "Cupón por entrega demorada",
  "FoodB_20260130_bbbs_MbgJ": "Registro de visitas",
  "FoodC_education__1_IIfh": "(1) Si cancelaste antes de que la tienda haya aceptado el pedido con la función \"Cancelar pedido\" que está en la sección de Detalles del pedido.",
  "FoodB_0905__vMsv": "{{number}} pedidos más que antes",
  "FoodB_Contract_cBzR_gTDZ": "¿El acuerdo incluye comparación con precios del competidor?",
  "FoodD_messagemanagement_Mail_UMqH": "Correo electrónico",
  "Gattaran_selection_TfHc_eCVN": "Productos pendientes de la lista de verificación de tiendas inspeccionadas",
  "FoodOpB_Tool_Completed_MjfD": "Finalizado",
  "FoodB_20260130_wrHU_Ggnu": "Habilidades de consultoría y diagnóstico",
  "FoodB_comparison_utxs_QFHY": "Confirmar coincidencia",
  "FoodOpB_1_Visit_tomorrow_ptjT": "Mañana",
  "FoodOpB_system_DiDi_ALAy": "Asociación con DiDi",
  "Gattaran_202406_hoAo_HpXw": "Recibidas ({{N}})",
  "Gattaran_0_KP_tendency_YwDf": "Método de contacto preferido del representante de la tienda",
  "FoodB_collection_Taxpayer_ID_zntM": "CURP",
  "FoodB_V2_No_store_ahBo": "Falta RFC (Registro Federal de Contribuyentes) *only mx",
  "FoodB_0617_pPbU_koUF": "Hay un contrato de exclusividad con la competencia - U",
  "FoodC_202412_QwDD_sIOi": "Fuera de la zona de entrega",
  "FoodB_subsidy_czaK_LuDh": "La aplicación de Asesor no admite la firma de contratos para este tipo de tienda. Acude a GTR para firmar el contrato.",
  "FoodB_tagging_You_have_ssrJ": "Decidiste invalidar este socio potencial por el siguiente motivo: \"No es una tienda de venta minorista\". Para hacerlo, debes cargar una foto o el número de contacto del representante de la tienda.",
  "FoodB_20260130_BKrl_bwum": "Fecha de seguimiento",
  "Gattaran_schedule_qPDb_CTYm": "Generar ruta",
  "Gattaran_202311_JOTQ_efhW": "No hay visitas recomendadas",
  "Gattaran_0_App_Operator_PFUQ": "Nombre del operador de la app",
  "FoodB_20250414_pQls_dkIZ": "Usuarios recurrentes",
  "FoodC_202410_UazG_LTwS": "No hay tiendas disponibles",
  "FoodB_process_mpIE_dSWO": "Rectificación fallida",
  "FoodB_governance_coYD_UvmL": "Rectificación en línea multiplataforma completada o no",
  "FoodC_202410_hAya_NcZF": "Confirmar ({{countdown}} s)",
  "FoodB_Show_Special_Tax_Eidl": "NIT (Número de Identificación Tributaria)",
  "FoodB_Contract_rrZL_POpC": "El precio de {{brand_name}} es {{unit}} {{number}}% del precio para consumo en el lugar",
  "Gattaran_0_Self_marketing_BQlO": "Autopromo",
  "FoodC_education__2_KZTZ": "(2) El socio repartidor no pudo contactarte",
  "Gattaran_Optimization_VLZp_WhPs": "Ver la dirección de la tienda",
  "FoodB_leads_KP_Phone_hCUe": "Teléfono 2 del representante de la tienda",
  "FoodOpB_APP_Visit_vdze": "Visitar",
  "FoodB_Contract_PpIv_FHlg": "¿El acuerdo incluye recompensa de tarifa de servicio?",
  "FoodB_Wordings_DKwT_wbfI": "Indica por qué elegiste esta opción. Tus comentarios son valiosos y nos ayudan a mejorar.",
  "FoodB_new1_Similarity_ItET": "Similitud",
  "FoodB_V2_iZpC_KKcK": "Compartir reporte de diagnóstico con la tienda",
  "FoodD_h5_Single_quantity_lrNq": "Pedidos completados",
  "FoodOpB_1_New_Visiting_tIni": "Crear plan de visita",
  "Gattaran_statusbar2_HKvC_dhsJ": "Firma",
  "FoodC_20240607_qihL_obWb": "No se encontró la tienda",
  "Gattaran_form_Iqrg_LVTe": "Ingresa un número",
  "FoodC_202409_rOOL_Peyp": "Ingresar número de celular",
  "FoodB_v108_kOdQ_AxDe": "ID de la tienda",
  "FoodB_1106_rrpW_kMlP": "Resumen de IA",
  "FoodD_Name_July_RJXL": "Jul",
  "FoodB_email_Bwgs_muyN": "Empleado",
  "FoodOpB_bill_Status_doqj": "Estado",
  "FoodOpB_1_Closed_ieMb": "Cerrada",
  "FoodC_check_HTib_sWqA": "Realizando pedido",
  "FoodB_20250414_cwcj_LKFT": "P2",
  "Gattaran_V1__xaNO": "Tasa de cancelación",
  "FoodC_intostore_Store_Coupon_kHwh": "Cupones de la tienda",
  "Gattaran_mgt_Filter_WuXS": "Filtro",
  "Gattaran_REGULAR_xhms_NLbn": "Restablecer",
  "FoodB_survey_wjGW_FMpe": "Asistencia financiera de {{brand_name}}",
  "FoodC_homepage_Enter_delivery_IZAu": "Ingresar dirección de entrega",
  "Gattaran_opt_nyES_OcBw": "Orden",
  "FoodC_Card2_When_the_sFOa": "Abre a las",
  "Gattaran_opt_slKF_FRuu": "Cancelar porque se acabó el tiempo",
  "FoodB_0905__dSOH": "Diagnóstico de la tienda",
  "Gattaran_opt_xozr_fXeD": "Mes en curso R Burn",
  "FoodB_collection_12_or_woYo": "Debe contener 12 o 13 caracteres alfanuméricos, todos en mayúsculas sin espacio",
  "FoodB_Launch_DR_Military_Rxvi": "Cédula Militar",
  "FoodB_Contract_UTbX_JhBf": "¿El acuerdo incluye comparación con precios para comer en el lugar?",
  "GRider_dlp_Mjnq_pnxH": "Más información",
  "FoodOpB_CO_Store_official_VsRU": "Sitio web oficial de la tienda",
  "FoodC_202408_HkLu_Mwgv": "No hay permisos de ubicación",
  "FoodC_202408_QAer_OYaB": "¡Bienvenido!",
  "soda-c-i18n---1、超时赔付服务是%s为您免费提供的服务，当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在中查看。": "1. Nuestra forma de remediar las cosas es compensarte por una entrega con demora. Si un pedido no se entrega en el tiempo de entrega estimado (salvo los pedidos cancelados), %s te dará uno o más cupones gratis. Puedes ver los cupones una vez que se complete el pedido en",
  "FoodC_edit_SkdG_WQKu": "Encontrarse en la recepción del hotel",
  "FoodB_Contract_Jthe_YSbD": "¿Se actualizó la información de encuesta para la tienda?",
  "FoodB_20260130_RUfF_qIDg": "Calificación de la etapa: preparación estratégica",
  "FoodC_education_1_Customers_Gpbb": "1. Antes de realizar un pedido, elije la mejor opción de entrega para ti. El socio repartidor te entregará el pedido según la opción que selecciones:",
  "Gattaran_Collection__oNFU": "Navegar con Google Maps",
  "Gattaran_20240401_iGPg_djYX": "Responder ahora",
  "Gattaran_0__eeft": "Todas las tiendas",
  "FoodB_1106_uAeK_oOBq": "Por favor, describe el trabajo que hiciste. ¿Cuáles son las actualizaciones clave, las necesidades de los usuarios o los problemas esenciales? ¿Cuáles son los próximos pasos?",
  "FoodD_Name_April_UHuR": "Abr",
  "FoodC_20240607_STdK_ZTMu": "Servicio técnico proporcionado por {{brand_name}}",
  "Gattaran_opt2_mgat_VXCg": "Conversión Funnel",
  "soda-c-i18n---将赔付给您1张%s优惠券": "Obtienes un cupón de %s",
  "FoodC_20240607_Olbe_DAqS": "No se puede cargar",
  "FoodB_20250414_oAyQ_liSz": "Descuento final",
  "FoodOpB_system_offline_ersI": "Fuera de línea",
  "FoodB_V1_pVrj_FQgt": "Id. del proyecto",
  "Gattaran_Grocery__pKzk": "Despensa",
  "FoodC_sidebar_Scan_QR_ONzJ": "Escanea el código QR con la cámara de tu celular",
  "FoodB_20260130_Asip_cJgN": "Por favor, ingresa una descripción de al menos 15 caracteres.",
  "FoodOpB_systemV2_Corresponding_coefficient_nVdO": "Coeficiente",
  "FoodD_Name_January_lhYr": "Ene",
  "FoodB_1106_wohA_bqJX": "La IA está realizando el análisis y el resumen. Por favor, vuelve a revisar más tarde.",
  "FoodB_1106_tdLw_uSLP": "Todos",
  "Gattaran_opt_oUrr_YTIV": "Barra del estado de la firma",
  "FoodOpB_tool_Category_main_aHZl": "Categorías principales de productos",
  "FoodB_email_CuqE_WLmP": "",
  "FoodB_20250122_yAtY_FAOX": "Ejecutores de la tarea",
  "FoodB_20250414_hanC_RXkJ": "P1*P2",
  "Gattaran_0_Role_QDBu": "Rol",
  "Gattaran_V20__THMR": "R Rendimiento",
  "Gattaran_form_xJkV_MADh": "Notas",
  "Gattaran_0__ypdc": "Actualizar",
  "FoodB_up20241218_Btbi_AOsy": "Enviada",
  "Gattaran_Gattaran_tXqW_GKCv": "En curso",
  "Gattaran_REGULAR_TWeg_lFbm": "Este campo es obligatorio",
  "FoodB_governance_OZDM_JqJt": "Rectificación por comparación de precios con la competencia completada o no",
  "Gattaran_management_adiS_UvoW": "No hay tareas de visitas",
  "FoodB_V1_hSCx_tzLn": "Nombre del proyecto",
  "Gattaran_Page_Distance_jPzG": "Distancia",
  "Gattaran_0_Menu_optimization_hWWT": "Desarrollo del menú",
  "FoodC_202408_uMeD_ECQU": "Hubo un error. Por favor, inténtalo de nuevo.",
  "Gattaran_form_MLcA_tPgo": "Este campo es obligatorio",
  "FoodB_requirement_puhp_VPIQ": "Pedidos no preparados a tiempo",
  "FoodB_20250612_SduQ_XghF": "Debes ingresar entre uno y 10 dígitos",
  "Gattaran_202406_wGfZ_ewxp": "Equipo de ejecución de la tarea",
  "FoodB_APP_BKjc_PGqI": "Anuncio de tienda",
  "FoodB_0905__zFVs": "Peso total",
  "FoodC_education_Platform_Delivery_MJPQ": "Entrega coordinada a través de la plataforma",
  "FoodB_management_Name_of_EjQd": "BDM account",
  "Gattaran_mgt_Check_the_Zyhr": "Ver la lista de las tiendas evaluadas",
  "FoodC_202408_HNlI_lTpJ": "No has dado un agradecimiento",
  "FoodC_dish_Look_again_fJrp": "Ahora no",
  "Gattaran_KPI_System_performance_cQiV": "Completación calculada por el sistema",
  "Gattaran_Visit_Change_2_mNNS": "Cambio 2",
  "FoodC_nonaffiliate_Courier_is_iunG": "El socio repartidor va en camino a la tienda para realizar tu pedido.",
  "FoodB_20250414_dobD_hNij": "Tasa de nuevos usuarios",
  "Gattaran_Optimization_AFCF_zMMS": "Llamar a personas de contacto",
  "FoodB_20260130_AmlG_nQAn": "Gestionar aspectos operativos y fundamentales",
  "FoodC_202408_IBpM_TxlD": "Otro",
  "必选": "No es posible desactivar",
  "FoodB_20250612_GGEs_TCgn": "Debes ingresar 10 dígitos",
  "FoodB_20260130_jZbm_FSzF": "Capitalizar oportunidades del entorno (enfoque en el negocio)",
  "FoodB_0707_High_prices_fBsL": "Más altos",
  "FoodB_process_kiMF_XkhA": "Confirmación pendiente",
  "Gattaran_0_Select_Contact_UrRS": "Seleccionar persona de contacto",
  "FoodB_0921__isZD": "Tasa de productos calificados",
  "FoodB_1106_LmPI_RZuR": "El permiso de registro está desactivado. Por favor, actívalo desde la Configuración.",
  "FoodC_202409_yzRW_xKLM": "Este pedido está cerrado. Para ver los detalles, ingresa el número de teléfono celular del solicitante.",
  "FoodB_20250414_faVK_FFkd": "Tasa",
  "Gattaran_transformation__zjbG": "Número de identificación del firmante",
  "FoodB_Contract_nsIw_Gfzl": "El precio de {{brand_name}} es {{unit}} {{number}}% del precio de la competencia",
  "FoodB_Translation_kinT_foeX": "Elige el motivo del estado no resuelto",
  "FoodB_20260130_msue_tVrT": "Actitud y aprendizaje continuo",
  "FoodC_web_Application_Progress_UYtG": "Estado de solicitud",
  "Gattaran_202311_XTsd_OBZL": "A {{distance}} de la tienda",
  "FoodB_1106_qhrP_Bevz": "¿Qué trabajo se hizo?",
  "Gattaran_202406_PESn_Wyzj": "Información de referencia",
  "FoodC_edit_GeFS_ZPLW": "Dirección y nombre del edificio",
  "Gattaran_form_wrkw_ybam": "Objetivo",
  "FoodB_audit_Similarity_check_cQEP": "Evaluación de similitud",
  "FoodB_Translation_vZUg_djAJ": "Elige el resultado de la resolución",
  "FoodC_202408_zoCD_Pszh": "Continuar",
  "FoodC_supplement_Return_wVpv": "Atrás",
  "FoodOpB_CRM_Taxpayer_full_fzhk": "Nombre completo del contribuyente (nacional)",
  "FoodB_APP_kvLF_MMXl": "Pedidos completados diariamente",
  "FoodB_calculator_yiXt_NkiM": "Comisión DiDi",
  "FoodB_20231012_Usvn_HuCU": "La tarea se creó con éxito. Puedes seguir el progreso en el módulo Mis tareas.",
  "FoodB_20250122_cjEP_PzzB": "Equipo de creación de la tarea",
  "FoodB_5_Store_Delivery_PIyN": "Entrega por parte de la tienda",
  "FoodB_calculator_JGZb_tQiY": "Precio para el usuario",
  "Internal_Tools_0523_djkV_XXks": "Lista de eventos registrados",
  "FoodB_field_Do_you_mhOz": "¿Sujeto al pago del IVA local?",
  "FoodB_B86_UdlE_SMWM": "Confirmar",
  "FoodB_calculator_pEyx_wJvY": "Sí",
  "FoodB_0820__bVDh": "Alta prioridad",
  "FoodB_20260130_BNSE_KtQJ": "Uso consistente de herramientas de gestión y datos",
  "FoodC_education_5_Cash_zBuY": "5. Si realizas un pedido con pago en efectivo, procura tener suficiente dinero a la mano para pagar el pedido antes de aceptar la entrega.",
  "Gattaran_0__ztLy": "Retroalimentación",
  "FoodB_management_Role_yLYi": "Rol",
  "FoodB_CL_Traditional_companies_cQhK": "Sociedad de sistema tradicional",
  "Gattaran_0__Auzn": "Arrastra el mapa para cargar más tiendas",
  "FoodB_B86_UDxy_zyJV": "Esta tienda no tiene registros de irregularidades durante el periodo actual",
  "FoodOpB_CRM_Taxpayer_Tax_xOmZ": "Número de identificación fiscal del contribuyente (local)",
  "FoodB_20260130_oTtg_HpPm": "Mejorar el conocimiento detallado de los productos y la oferta comercial",
  "FoodC_202408_PvIX_VPCT": "Ingresa para ver ofertas y rastrear tu pedido",
  "FoodOpB_Tool_Supplies_Vptd": "Suministros",
  "FoodB_1106_zQzq_GRVj": "Este dispositivo no admite grabaciones",
  "FoodB_20260130_yite_dEGG": "Se generaron los pasos siguientes con fechas de compromiso",
  "FoodD_Name_August_cjQS": "Ago",
  "FoodOpB_system_DiDi_XcUY": "Operaciones de DiDi",
  "FoodB_calculator_VFoE_zsGK": "Costo del producto",
  "Gattaran_management_WjPM_jAvI": "Enviar acuerdos a la tienda",
  "FoodB_V1_daZW_gxxe": "Tipo de proyecto",
  "Gattaran_84_pFOg_DKGB": "Contenido de la infracción",
  "FoodOpB_2_Activity_status_hKFd": "Estado de la campaña",
  "Gattaran_opt_klQH_BPVb": "Lead Info",
  "FoodB_v108_Qpgb_cAfC": "Nombre/ID del proyecto",
  "Gattaran_REGULAR_JVAQ_pbxi": "Entrada básica",
  "Gattaran_statusbar2_HSiT_INfG": "Verificado",
  "Gattaran_v2_meyK_ACyX": "Abrir en {{DiDi_Top}}",
  "Gattaran_20240902_XVee_UUPM": "{{account}} rechazó esta tarea. Motivo: {{reason}}. Por favor, inicia sesión en el módulo Gestión de tareas de ventas del sistema GTR para completar nuevamente la información de referencia y luego enviarla.",
  "Gattaran_202406_lNdD_KvZI": "Tareas de la tienda ({{N}})",
  "Gattaran_V1_HNYI_VwLG": "tienda(s) no se ha(n) registrado",
  "FoodB_collection_Tax_Classification_uJHT": "Régimen fiscal del contribuyente",
  "Gattaran_202406_FRwK_cCbx": "Mi tarea",
  "FoodB_APP_YjyK_hqYn": "Pedido",
  "FoodB_Optimization_QsfU_elzm": "Por favor, selecciona un tipo de tienda",
  "FoodB_calculator_AioF_coBc": "IVA sobre base gravable",
  "Gattaran_0_Marketing_activities_qANU": "Promociones",
  "FoodB_up20241218_hGVF_hBSj": "Esta tienda no tiene productos que cumplan con los requisitos. Sugerimos contactar a la tienda pronto para cargar los productos.",
  "Gattaran_Project1_HXjY_OZWN": "Alerta de conflicto con la recompensa de tarifa de servicio",
  "FoodB_20260130_dqca_vtcE": "Seguimiento y cumplimiento",
  "FoodC_dish_Leaving_LwWJ": "Salir",
  "FoodB_CL_RUT_roUA": "Número de identificación fiscal del contribuyente (nacional)",
  "FoodC_202408_IfNx_VyNu": "Direcciones guardadas",
  "FoodB_optimization_Full_reduction_NlOa": "Gasta X, Ahorra Y",
  "FoodC_dish_You_will_AXAT": "Sólo puedes disfrutar de descuentos para nuevos usuarios en esta página.",
  "Gattaran_add_WtmN_hzJP": "Conectividad > 60%",
  "FoodC_edit_NwrE_OHgM": "Encontrarse fuera del edificio de departamento",
  "FoodB_data_End_mVwX": "Hora de cierre",
  "FoodB_20260130_VWIQ_JMLw": "Habilidades de negociación",
  "FoodB_0327_ZGTe_zcKH": "Pulsa aquí para cambiar de ciudad",
  "Gattaran_0__NAOt": "Puedes describir el problema o dejar tus sugerencias en el siguiente correo electrónico o mandar un mensaje por D-Chat.",
  "Gattaran_visit_KjUG_kxHP": "El BD enlista los programas promocionales y revisa las necesidades de la tienda",
  "FoodC_education_1_If_iWDm": "1. Si no te es posible seguir las reglas anteriores para recibir un pedido, podría considerarse que el inconveniente relacionado con la entrega fue tu responsabilidad. Esto incluye, pero no se limita a, situaciones en donde:",
  "Gattaran_0509_PLgH_VDtS": "Los 10 mejores platos",
  "Gattaran_optimization_deWd_ffjJ": "Finalización de rendimiento final",
  "Gattaran_0_Decision_makers_uOOG": "DM(representante de la tienda)",
  "FoodB_V2_No_legal_QONX": "Falta la identificación del representante legal",
  "FoodB_20260130_fEgm_UwHu": "Acompañamiento y seguimiento",
  "FoodB_Commision_Type_of_EIWZ": "Tipo de tienda",
  "Gattaran_mgt_Unqualified_Store_JeWr": "Tiendas con objetivos no logrados",
  "FoodB_Overview_AasD_LvfW": "Ver más",
  "FoodB_NewStore_Status_HphC": "Estado",
  "Gattaran_20240401_kuua_DPLO": "Preguntarme más tarde",
  "FoodB_list_Store_Phone_tSWo": "Número de teléfono de la tienda",
  "Gattaran_visit_KNGQ_NwUQ": "El BD enlista los acuerdos anteriores",
  "Gattaran_opt2_kPIo_ZpuU": "Self Delivery Semanal Ordens",
  "FoodB_communications_mtxm_YcRA": "tiendas que no completaron las acciones para el impulso de tiendas nuevas",
  "FoodB_V1_zSAb_YlGe": "Días restantes: {{num_days_left}}",
  "Gattaran_84_BAfy_jvHS": "Identificación de la infracción",
  "FoodB_20260130_JgHk_zEgk": "Incrementar la efectividad del acercamiento con el DM",
  "Gattaran_management_Associated_New_iDiy": "Asociar la nueva tienda",
  "Gattaran_202406_HnXs_yYCh": "Estado de la tarea",
  "Gattaran_form_wuYy_lqzb": "Información de la plataforma",
  "FoodB_module_gRmW_pNjB": "Periodo de los datos: {{date}}",
  "Gattaran_management_HgTV_cHfW": "Agregar plan",
  "Gattaran_B86_AJdW_BXRv": "Tasa de horas en línea en {{number}}",
  "Gattaran_jumppromo_ONbQ_nOEB": "Portal de datos de la promoción",
  "FoodB_420241024_LTYv_GOfN": "Valor final",
  "FoodB_optimization_Label_nzNw": "Etiqueta",
  "FoodB_process_EHJE_CoxL": "Elegir subproducto",
  "FoodB_P0_cNyW_HkyE": "Cambios en pedidos completados",
  "FoodC_edit_OVRs_CzUt": "Hotel",
  "FoodB_20230410_YNjt_xAWA": "Tienda DiDi Top",
  "Gattaran_optimization_MwZK_gJdn": "Adicional de KPI",
  "FoodOpB_Tool_Visit_szxD": "Link abierto",
  "FoodC_202408_leda_oOpl": "Mejor control de pedidos",
  "FoodB_V1_LADl_QUme": "Completar formulario",
  "FoodB_list_Setting_Up_YlBy": "set_open_duration",
  "Gattaran_84_IIJR_tPfw": "Método de identificación",
  "FoodB_1106_Boir_tlSu": "No se pudo cargar el archivo de audio. Por favor, asegúrate de que tu red sea estable y que el archivo tenga menos de 5 MB y menos de {{max_record_time}} segundos de duración.",
  "Gattaran_statusbar2_Pfzu_ihne": "Verificando",
  "Gattaran_opt_SsHX_vUuN": "Cancelar porque está agotado",
  "Gattaran_schedule_saMI_wHLe": "Toca aquí para generar una ruta de visita presencial",
  "sailing.d-api.common.页面获取失败，请稍后重试": "No se puede recuperar la página. Vuelve a intentarlo más tarde",
  "Gattaran_0_Merchant_activities_wwGb": "Flagship",
  "FoodB_20260130_ifDg_nokH": "Hubo planeación y preparación de la ruta efectuada en el día",
  "Gattaran_Translation_Alien_ID_IMja": "Carné de Extranjería",
  "soda-c-i18n---当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在": "Si un pedido no se entrega en el tiempo de entrega estimado (salvo los pedidos cancelados), %s te dará uno o más cupones para remediar las cosas. Una vez que se complete tu pedido, puedes ver los cupones en",
  "FoodB_20260130_oIxI_wIMq": "Dominio del pitch comercial",
  "FoodB_APP_PJrW_uBye": "AOP/ASP",
  "FoodB_V1_CLCC_nUuk": "Crear visita",
  "FoodB_20260130_HkWX_ZAoO": "Escucha activa y comunicación adaptativa",
  "FoodB_I_Home_OrRo": "Inicio",
  "FoodB_collection_Taxpayer_Information_fQid": "Consultar información fiscal",
  "FoodC_202408_GeGr_xwdt": "Comunicación más sencilla",
  "Gattaran_202406_cPQJ_uCFE": "Tipo de tarea",
  "FoodB_comparison_FSKj_kcIf": "Los resultados de la comparación están en revisión",
  "FoodOpB_information_The_selected_LyoI": "El pago no es compatible con el banco seleccionado.",
  "FoodD_Name_September_Ezci": "Sep",
  "FoodC_202408_xwYJ_IzdZ": "Continuar",
  "FoodB_0_Mail_SUKZ": "Correo electrónico",
  "Gattaran_202406_ndOn_KPLE": "Detalles de la tarea",
  "Gattaran_opt2_Nngy_DhyN": "El estado de revisión ha vencido y no puede consultarse aquí. Ponte en contacto con el supervisor del producto correspondiente para obtener más información.",
  "FoodB_calculator_VujK_GJbV": "Utilidad",
  "Gattaran_Visit_Accompanied_visitors_ZFNA": "Personas que serán acompañadas",
  "FoodB_calculator_mTaD_pjZv": "Descuento total",
  "Gattaran_0_Improved_Cancellation_KpWF": "Mejorar tasa de cancelación",
  "FoodB_20260130_JGEK_zxII": "Adapta el discurso reconociendo la propuesta de valor de {{brand_name}} y los principales beneficios de la oferta comercial vigente",
  "Gattaran_Visit_Before_visiting_VHLe": "Inicio del día",
  "Gattaran_mgt_Display_all_Yagb": "Por defecto, se muestran todas las tiendas que no lograron los objetivos y sus KPI",
  "Gattaran_store_nPds_FcDF": "Esta página no es el portal oficial para la firma del contrato. Por tu propio bien y por la seguridad de tu información, por favor, completa la firma del contrato a través del portal oficial.",
  "FoodC_1_mnqk_AcOb": "No se pudo copiar",
  "FoodB_CL_Amount_CLP_Tmnv": "Monto (CLP)",
  "Gattaran_84_fTVF_JwVK": "Infracción general",
  "FoodC_202408_ZOBi_xjfW": "Buscar nombre del edificio/departamento",
  "FoodOpB_CO_Not_applicable_WuPn": "No aplica",
  "FoodC_supplement_Modify_Mobile_ZJkT": "Para modificar tu número de teléfono o tu contraseña, agregar una dirección de correo electrónico o eliminar tu cuenta,",
  "FoodC_address_gNYi_HdzX": "No se pudo guardar",
  "FoodD_supplement_Rules_RYAa": "Reglas",
  "FoodB_email_qCka_NBMf": "Hora preferida para contactar",
  "FoodB_tagging_You_chose_DSiT": "Decidiste invalidar este socio potencial por el siguiente motivo: \"Operaciones detenidas\". Para hacerlo, debes cargar una foto o el número de contacto del representante de la tienda.",
  "Gattaran_opt_cUSL_RSNr": "Navegación por mapa e información de contacto",
  "Gattaran_form_YzJW_ggnb": "Información sobre las operaciones de la tienda",
  "FoodB_0919__YKYU": "Sin promociones",
  "FoodB_calculator_mdtN_KpDW": "Descuento total",
  "FoodB_20260130_YoXd_Ofsz": "Documenta el estado de sus visitas correctamente y gestiona los resultados en Explorer, asegurándose de enviar los acuerdos establecidos al restaurante",
  "Gattaran_202406_jIoA_BlIm": "Mostrar",
  "FoodB_survey_zzNV_gkFf": "Notas",
  "FoodD_up_DiDi_Delivery_FdmM": "DiDi Repartidor",
  "FoodC_202408_pSzr_CJqz": "Guardar dirección",
  "Gattaran_management_hCqr_uwez": "Editar correo electrónico",
  "FoodC_202412_JiED_bPrx": "Sin resultados. Ingresa una calle y número válidos.",
  "Gattaran_0_Operating_channels_upHR": "Pedidos por día",
  "FoodB_20250414_EVlU_bloy": "Nuevos usuarios",
  "Gattaran_AlertV1_FkFa_EQiG": "Tiendas no elegibles",
  "FoodB_V1_BEKq_hBNG": "Filtros seleccionados: {{tag_name}}",
  "FoodC_1_ScPa_MVPN": "Copiado",
  "Gattaran_management_BjBQ_GVEr": "{{num1}}/{{num2}} visitas finalizadas·{{month}}",
  "Gattaran_REGULAR_ezuA_ZuBN": "RFC",
  "FoodC_all_You_haven_lSmt": "Aún no invitas a tus amigos. Intenta enviar una invitación.",
  "FoodB_calculator_rMFF_EMXI": "Efectivo",
  "Gattaran_AlertV1_MmvI_acwe": "{{date}} día(s) restante(s)",
  "FoodB_Translation_IcyT_qdIf": "A rectificar",
  "Gattaran_mgt_Without_search_XVsz": "No se encontraron resultados. Puedes ajustar las condiciones de filtrado e intentarlo de nuevo",
  "FoodB_20250414_WmJY_oZbB": "Gráfico de embudo",
  "FoodB_calculator_HfHr_bkLf": "Subsidio de DiDi sobre el descuento total",
  "FoodC_education__3_TDsa": "(3) Te negaste a recibir el pedido, ya sea una parte del mismo o completo",
  "FoodB_B86_xkRX_bJPm": "¿Es precisa la información sobre las irregularidades?",
  "FoodB_1106_tTbZ_mKRW": "Análisis de IA",
  "FoodB_Launch_DR_ID_AnVk": "Cédula Dominicana",
  "Gattaran_management_oCmv_JtTy": "Acuerdos Pactados de DiDi",
  "FoodB_CL_Vista_Account_QcOm": "Cuenta vista",
  "Gattaran_BDapp_Rvoe_RUHw": "BD Portal (Normal)",
  "FoodB_I_onwf_oaQH": "Ventas",
  "FoodB_process_keoD_znIy": "No se encontró ningún producto coincidente",
  "soda-c-i18n---订单实际送达时间晚于预计送达时间%s分钟以上，": "Si tu pedido llega %s minutos después del tiempo de entrega estimado,",
  "soda-c-i18n---取消订单": "Cancelar pedido",
  "请选择支付方式": "Selecciona un método de pago",
  "Gattaran_KPI_ioIq_fNJB": "First online date",
  "Gattaran_Feedback__dWQe": "Responsable de la tarea",
  "FoodB_progress_ZdQT_mHfK": "Restablecer",
  "FoodB_calculator_Jryi_aded": "Personería fiscal",
  "Gattaran_jumppromo_vqdm_KQKO": "Toca aquí para abrir el Portal de datos de la promoción y ver datos más detallados",
  "FoodD_Optimization_ppct_mVEc": "Ingresa tu número",
  "FoodB_0_Please_upload_dcPG": "Carga una captura de pantalla del historial de mensajes de texto",
  "FoodC_dish_Are_you_TaUN": "¿Salir de la página de la promoción?",
  "FoodB_20260130_XIop_NNlH": "Confirma que el DM comprendió los acuerdos y establece los pasos siguientes",
  "Internal_Tools_0510_DBOY_ADvH": "Horario de atención en día festivo no establecido",
  "FoodB_CL_Add_any_egRn": "Es aceptable cualquiera de los siguientes tres documentos:\nPoder notarial\nCertificado del Registro Público de Comercio de México (o ciudad respectiva)\nCertificado de Estatuto Actualizado",
  "FoodB_20250612_jtyZ_DrEC": "Amigo/familiar del propietario de la tienda",
  "FoodB_0617_rPjX_pvuu": "¿El restaurante recibe pedidos por WhatsApp o teléfono?",
  "Gattaran_form_FtqP_caNF": "Objetivo de la visita",
  "FoodC_202412_aCvV_UNyj": "Agregar nueva dirección",
  "Gattaran_Visit_Results_ftOU": "Resultado",
  "Gattaran_0_Improvement_of_TPKB": "Mejorar los malos comentarios",
  "FoodB_0830__wEQD": "Pedidos completados en este mes",
  "FoodB_1106_OZBo_RTDB": "Intención del usuario",
  "Gattaran_side__vcvR": "Domingo",
  "Gattaran_84_Uwcd_PIjN": "Precio de {{brand}}",
  "Gattaran_opt_AGTs_VRUG": "{{change}} más que en el último periodo",
  "Gattaran_202406_iXbv_CcJq": "Información básica de la tarea",
  "FoodB_email_FvUP_tJQT": "Nombre",
  "FoodB_CL_Maximum_amount_oflZ": "Monto máximo permitido a deducir en una deducción (CLP)",
  "Gattaran_Visit_Date_of_TyAN": "Fecha de la visita con acompañantes",
  "FoodC_popup_After_closing_ujoW": "Si sales, no se guardarán los productos seleccionados",
  "Gattaran_management_nGle_XtpC": "Correo electrónico de la tienda",
  "Gattaran_Visit_Getting_ready_zDyf": "Preparación",
  "FoodB_20260130_LRgr_ZBuv": "Dominio de herramientas",
  "FoodOpB_management_Launching_HwsY": "Expandir",
  "Gattaran_management_IEaM_OfwD": "Nombre del contacto",
  "GDriver_trans_seconds_fFsz": "segundos",
  "FoodB_I_QuSz_HsAZ": "Descuento de promo %",
  "Gattaran_mgt_No_performance_GzjE": "No hay datos de rendimiento",
  "Gattaran_0229_SpOD_JZZs": "Esto puede deberse a las condiciones del filtro mutuamente excluyentes que seleccionaste en Asociación con DiDi, Fuera de línea y Operaciones de DiDi.",
  "FoodB_audit_The_information_jxLV": "La información que enviaste no cumple con los requisitos",
  "FoodC_Notification_ZawA_BoKt": "Ver pedidos en curso",
  "FoodB_420241024_TFhQ_lSww": "Se rechazó correctamente",
  "FoodB_optimizing_Duplicate_Store_aBYS": "Número de identificación de tienda duplicado",
  "Gattaran_202406_QyVz_DlrH": "Prioridad de la tarea",
  "FoodC_202412_Afcx_fMwc": "Seleccionar dirección",
  "FoodB_APP_eiHc_XFQQ": "Porcentajes de promoción",
  "Gattaran_Visit_Visit_process_dZws": "Durante la visita",
  "FoodB_1106_Ezht_DXlH": "El tamaño del archivo no puede ser mayor a 5 MB",
  "FoodB_20260130_JUUM_TDMw": "Oportunidades de mejora",
  "FoodB_V1_vKqg_VkFI": "Lista de proyectos",
  "Gattaran_Top_gxPb_uTLM": "3. Una vez que una tienda se convierte en DiDi Top, obtendrá algunas ventajas de tráfico que mejorarán de forma significativa el volumen de pedidos, así que ayuda a tu tienda a calificar para DiDi Top.",
  "FoodB_survey_CEvs_qbnA": "Porcentaje de tarifa de servicio del competidor – P",
  "FoodB_email_SHyg_fIzy": "Falta el correo electrónico. Por favor, agrégalo para enviar el correo electrónico",
  "FoodC_202412_enwa_nWfu": "Este producto está agotado. Puedes explorar otros productos de la tienda.",
  "Gattaran_url_TmcA_KzBM": "Enlace al menú {{Uber}}",
  "Gattaran_transformation__sLrG": "El signatario actual tiene un socio potencial en revisión. El contrato se podrá firmar una vez aprobado el socio potencial.",
  "FoodOpB_1_There_may_scoc": "Al parecer existe un conflicto de programación. El plan para la fecha seleccionada es:",
  "Gattaran_0_Create_new_Faau": "Crear persona de contacto",
  "FoodOpB_1_Are_you_sLNY": "¿Estás seguro de que quieres cerrar esta visita? Después de cerrar, la visita será inválida y no se podrán ingresar datos",
  "FoodB_20260130_UEYG_BeRR": "Sentido de urgencia",
  "FoodC_edit_KDUB_nVRR": "obligatorio",
  "FoodB_Contract_adlR_lBNU": "¿Se cargó correctamente el menú para comer en el lugar aprobado?",
  "FoodB_20260130_rYlT_MdwI": "Otro",
  "Internal_Tools_0523_XvOO_ugWO": "Registrado. Ver detalles.",
  "Gattaran_management_lLpT_dFdN": "No visitada",
  "Gattaran_visit_jnPQ_METw": "¿La persona que toma decisiones estuvo presente en la visita?",
  "Gattaran_202406_CvwH_Obyc": "Hora de finalización de la tarea",
  "FoodOpB_results_The_key_HHMa": "La persona clave no estaba en la tienda",
  "Gattaran_Feedback__WUQR": "Mis comentarios",
  "FoodOpB_1_A_recent_LtIi": "Ya existen uno o más planes de visita sin finalizar. ¿Estás seguro de que quieres ingresar datos?",
  "Gattaran_V20__eJGq": "Potencial",
  "Gattaran_optimization_qReN_wCHB": "Se actualizaron las tareas de visitas de este mes. Ver ahora",
  "FoodB_email_Zgsh_mNSy": "KP",
  "Gattaran_form_rWtU_nHko": "Selecciona",
  "FoodB_optimization_Special_Meal_YtqD": "Productos en promoción",
  "Gattaran_0_Prices_of_kkXs": "Los precios en DiDi contra el menú físico son",
  "FoodC_20240607_hfCf_kdpO": "Teléfono",
  "FoodB_task_UZKM_xysG": "Valor actual",
  "Gattaran_84_qedy_lUwd": "Nivel de infracción",
  "Groceries_web__Ovnh": "¡Lo sentimos! Por el momento sólo se puede acceder a las tiendas en la aplicación móvil.",
  "FoodB_IGV_WGYF_kfvV": "IGV",
  "Gattaran_opt_AIBq_AcbH": "Editar información del socio potencial",
  "FoodB_1106_dhXS_LAAs": "Error de generación del resumen de IA",
  "Gattaran_form_MhMj_Wboc": "Agregar información de la plataforma",
  "已选择": "Selected",
  "FoodC_edit_stZr_IBeA": "Otro",
  "FoodC_edit_AxtX_PAiY": "Ejemplo: Edificio C, 1118",
  "FoodB_20260130_uXlC_uqel": "Conversación comercial",
  "FoodOpC_backend_Urban_hhdx": "Ciudad",
  "FoodOpB_app_Need_to_XZYr": "Requiere visita presencial (o física)",
  "Gattaran_opt_bWcH_ShAH": "Agregar Planes",
  "FoodB_Analysis_Yesterday_nearly_aBCt": "Ayer",
  "FoodB_calculator_ULXU_HjOF": "IVA",
  "FoodB_calculator_WKKD_DbHM": "Base gravable de pagos en línea",
  "FoodB_process_fSqQ_sYNN": "Ingresa el nombre del producto",
  "FoodD_Questionnaire_Finished_YvLk": "Listo",
  "FoodB_030_fqBt_uzDV": "Faltan permisos: {{City}}. Solicita un permiso en Gattaran.",
  "FoodB_1106_Jvwt_cvqA": "Cargar archivo de audio",
  "Gattaran_management_tfXo_jhuS": "Estado de la tarea",
  "Gattaran_opt_CjOE_rGuI": "Ver más información de la visita",
  "soda-c-i18n---早间：%s-%s": "Durante la mañana: %s a %s",
  "FoodD_Orders_Can_not_fkHK": "La hora de inicio no puede ser mayor o igual a la hora de finalización.",
  "FoodB_data_Beginning_PbJC": "Hora de inicio",
  "FoodOpB_Translation_Cash_accounts_fSLJ": "Cuenta corriente",
  "FoodC_orderlist_Completed_Xuod": "Finalizado",
  "FoodB_B86_vHgx_eMOl": "Actuales",
  "FoodOpB_tagging_Non_retail_JnDS": "No es un restaurante",
  "Gattaran_0__diqD": "Sin tiendas",
  "FoodB_1106_ZAuG_REFT": "¿Confirmas que deseas cerrar y salir? La grabación se detendrá y tu contenido no se guardará.",
  "Gattaran_Visit_Empathy_and_CvFh": "Empatía e inicio de la negociación",
  "Gattaran_0_Clerk_call_fhnx": "Número del empleado",
  "Gattaran_20240409_JERr_RtyH": "Ver todas las tiendas",
  "Gattaran_AlertV1_MVye_ihrr": "Coeficiente de rendimiento actual",
  "FoodB_1106_BLKp_thZN": "Información de seguimiento",
  "FoodOpC_system_Business_hours_coEs": "Estado del repartidor",
  "Gattaran_form_TTAw_lJPb": "Ingresa notas a modo de información complementaria",
  "FoodB_calculator_HXix_qhAK": "ISR sobre base gravable",
  "FoodC_202408_reKH_lclj": "Agregar dirección de entrega",
  "Gattaran_mgt_Achievement_GuwU": "Objetivos logrados",
  "Gattaran_Visit_Business_feedback_Llza": "Retroalimentación del negocio",
  "FoodB_phrase__PWcd": "No hay promos finalizadas para ver",
  "FoodB_1106_bquQ_ajOd": "Entrada de texto",
  "Gattaran_opt_ZCLf_SEBU": "Tienda ID",
  "FoodB_optimization_Not_started_XTpL": "No ha comenzado",
  "FoodB_email_wMIf_SGNM": "Nombre del contacto",
  "Gattaran_20240902_YGUw_avxA": "Rechazar",
  "FoodC_replace_Clear_Filter_iwTY": "Borrar filtros",
  "FoodB_030_SQUQ_YDRS": "No mis tiendas",
  "Gattaran_add_bXDc_IEuz": "Conectividad (Promedio Diario) > 60%",
  "FoodB_governance_OCvE_wAPt": "Gestionar ahora",
  "FoodB_Translation_JSTh_Vrzb": "Motivo detallado de la apelación",
  "Gattaran_online_HStX_yFLt": "Primera vez en línea",
  "FoodB_0622_Increase_store_kZfr": "Agregar comparación de tiendas",
  "FoodB_calculator_GdDU_bFgc": "Subsidio DiDi",
  "Gattaran_side__nJvf": "Miércoles",
  "FoodOpB_CRM_Party_B_BCQp": "Número de identificación de la empresa",
  "Gattaran_REGULAR_XlOa_yzqB": "Resultado",
  "FoodOpB_crm_Business_model_wjXI": "Modo comercial",
  "FoodB_calculator_BKfQ_ehtA": "Comisión DiDi",
  "FoodB_email_SdUD_YAhg": "Falta información. Por favor, agrégala para enviar el correo electrónico",
  "FoodB_1106_XrIH_sjvu": "Lo sentimos, se produjo un error en el análisis de tu grabación que hizo la IA.",
  "FoodB_0617_qTmE_PWeM": "¿Cuántos pedidos con retiro en tienda realiza el restaurante por día?",
  "FoodB_process_vjLl_iVPp": "Rechazada",
  "FoodC_20240607_Upph_ldoj": "Recordatorio de compra",
  "FoodB_calculator_VKAb_KHst": "Subsidio DiDi",
  "FoodD_Name_May_zYiz": "May",
  "FoodB_list_KP_Name_GQRs": "Nombre del representante de la tienda",
  "Gattaran_statusbar2_zVad_yPpm": "Rechazado",
  "Gattaran_20240409_cmyA_kTJa": "Registro abierto ({{num}})",
  "Gattaran_jumpnewstore_kzko_qHFR": "Toca para ver los datos del tráfico",
  "FoodB_communications_APfO_DcRl": "Acciones no completadas para el impulso de tiendas nuevas",
  "Gattaran_20240409_krBB_ZQnQ": "No iniciadas ({{num}})",
  "Gattaran_management_HNXE_vNoU": "Identificación de la tarea",
  "FoodC_edit_JdIz_uKvw": "Encontrarse afuera",
  "FoodC_education_In_order_SRIb": "Esta política de cancelación se creó para ayudar a que todos los usuarios tengan una buena experiencia con {{brand_name}}.",
  "FoodB_Show_Taxpayer_Document_eadz": "Tipo de documento fiscal (local)",
  "Gattaran_opt_Qotr_nHZK": "Datos Operativos",
  "Gattaran_v1_pVFJ_UAfK": "Registrar tienda para la promoción del evento",
  "FoodC_202408_LBac_RLgP": "Agrega la dirección de entrega para que el repartidor pueda entregar el pedido",
  "FoodOpB_center_Rejection_FiOu": "Rechazar",
  "Gattaran_management_SqSM_FwHJ": "Visitada",
  "Gattaran_statusbar2_QQFK_mEcw": "Verificar",
  "FoodC_202408_BsWi_bWTi": "Editar dirección",
  "FoodB_1106_hYOE_wfgV": "Vista previa de resultado de reconocimiento",
  "FoodC_202408_LtuD_oTxz": "Cancelar",
  "FoodB_V1_hqNE_fQDz": "proyectos",
  "FoodC_sales_If_the_TsPm": "Para ayudarnos a verificar el problema con la tienda y el socio repartidor, por favor dinos si el pedido fue entregado en un empaque resellable o sellado de alguna otra forma (como con grapas).",
  "FoodB_Analysis_Nearly_7_wumh": "Últimos {{day}} días",
  "FoodB_2_During_the_QHhU": "Periodo de registro",
  "Gattaran_202406_ODsG_JrEY": "tareas sin completar",
  "Gattaran_Visit_Formula_item_xqos": "Fórmula = (puntaje del evento 1 / 4 + puntaje del evento 2 / 4 +...) / cantidad de eventos * 100 %",
  "FoodB_process_WMCl_eXXl": "En apelación",
  "Gattaran_ES_ZfMz_IKyd": "Conectividad",
  "FoodC_education__2_uVUK": "(2) La tienda a la que le hiciste el pedido estaba cerrada, un producto estaba agotado, ocurrió un accidente o la tienda o el socio repartidor cancelaron el pedido por otro motivo. En ese caso, recibirás un reembolso completo.",
  "Gattaran_transformation__AByw": "Tipo de signatario",
  "FoodB_V1_VKlO_UPTE": "Descripción del proyecto",
  "FoodB_orders_Select_Store_gtmG": "Seleccionar tiendas",
  "FoodB_audit_Suspected_duplicate_ntLx": "Posible tienda duplicada",
  "FoodB_20260130_zsJf_PMwY": "No aplica",
  "FoodB_20260130_sqnQ_jioF": "Dominio del producto y oferta comercial",
  "Gattaran_202406_VqOU_hMFa": "Prioridad del tipo de tarea",
  "Gattaran_202406_CltK_IQGG": "Creadas ({{N}})",
  "FoodB_Optimization_LfPz_zDPq": "Completar registro",
  "Gattaran_AlertV1_yVMN_aZdo": "Alertas de tiendas",
  "FoodB_Show_Taxpayer_Document_TFeg": "Tipo de documento fiscal (nacional)",
  "Gattaran_0_App_Operator_ikIT": "Operador de la App",
  "Gattaran_202406_ztqf_jOPK": "No completada",
  "Gattaran_202406_dDeL_ULkW": "Ver",
  "FoodB_Contract_yBjK_Ngdm": "¿El acuerdo es exclusivo?",
  "Gattaran_function__vJQK": "Estás usando la versión más reciente",
  "FoodB_1106_dvab_aMNJ": "Enviar",
  "Gattaran_visit_hZGE_sfuk": "Retroalimentación general",
  "Gattaran_Optimization_SGMS_fnOQ": "DiDi Food",
  "Gattaran_form_YnWW_YxTG": "Agregar persona de contacto",
  "FoodB_2503_JeQk_FWxd": "Cargando...",
  "FoodB_optimization_Buy_gifts_daUI": "Compra X, llévate Y gratis",
  "Gattaran_opt_EFMf_fxMF": "Última visita",
  "FoodC_update_The_expected_ZzFg": "El tiempo de entrega estimado se basa en el tiempo de entrega más reciente.",
  "FoodB_pt1_ofEk_bcpz": "Correo electrónico de la persona de contacto",
  "FoodC_202408_BTvL_umes": "¿Deseas salir?",
  "FoodB_B86_lRNJ_EMZv": "Sí",
  "FoodOpB_CRM_Taxpayer_Information_Flde": "Foto adjunta de la identificación fiscal del contribuyente (local)",
  "FoodC_202408_ReqK_LVas": "Confirmar",
  "Gattaran_opt_QCLu_UWmJ": "Cancelado Ordens",
  "Gattaran_0_Can_t_zMtY": "No se pudo contactar",
  "FoodB_model20250116_HPUj_zcce": "No se encontró la ubicación. No es posible marcar la hora de ingreso o salida. Por favor, activa los servicios de ubicación en la configuración del teléfono y permite que la aplicación de BD acceda a ellos.",
  "FoodB_420241024_rQXh_ONDO": "Se logró",
  "FoodB_system_Competition_NFPY": "Competidor",
  "Gattaran_84_yiob_OivQ": "Negro",
  "Gattaran_statusbar2_UQFc_DODT": "Siguiendo",
  "Gattaran_0_Publicity_cards_HSYt": "Stoppers",
  "Gattaran_management_fVhj_uFOo": "No dudes en contactarnos. ¡Gracias!",
  "FoodB_20260130_kPaF_pdwu": "Casi nunca",
  "FoodB_management_Untied_tYEF": "Desvincular",
  "Gattaran_form_mvdB_WqwR": "Agregar plan de acción",
  "Gattaran_visit_kYQA_ZYsK": "El BD maneja bien las objeciones de la tienda",
  "FoodB_20260130_WiZC_rYRd": "Nunca",
  "Gattaran_mgt_System_recommended_AeDM": "Orden recomendado",
  "FoodB_B86_AADM_isyE": "Cancelar",
  "FoodC_education__1_qvVC": "(1) No recibiste el pedido a tiempo",
  "soda-c-i18n---请告诉我们，帮助我们一起改善": "Escribe tus comentarios y ayúdanos a mejorar",
  "FoodB_calculator_RWNx_Xkrf": "Persona física",
  "Gattaran_optimation_QjMB_BOgo": "Abandonaste inesperadamente la página Formulario de visita de acompañamiento. Toca “Volver a abrir” para volver a la última página en la que estabas.",
  "Gattaran_form_jbbp_rBPM": "Salir",
  "Gattaran_transformation__hYxT": "Asociar signatario",
  "Gattaran_Edition_oXdU_Hnsz": "No se encontró lo que buscabas",
  "FoodB_process_nXaG_aweQ": "Detalles de la coincidencia",
  "FoodB_V1_zPrX_zWoE": "Cambios en la tasa de gastos/GMV",
  "FoodB_management_Sector_LRtz": "Departamento",
  "FoodB_0905__pNYF": "Los pedidos se superponen. La suma no refleja el total de pedidos completados cada día.",
  "FoodB_1106_SvnP_rxzP": "Listo",
  "FoodC_202408_XlDL_LjiM": "Entendido",
  "Gattaran_0_Price_management_rLvu": "Bajar los precios",
  "FoodB_0623_Store_GZFE": "Tienda",
  "Gattaran_opt_BEjW_mzFb": "El reporte de los datos se puede ver después de la primera conexión",
  "FoodOpB_results_No_store_ZJQG": "No hay información de contacto válida para la tienda",
  "FoodC_Website_DiDi_FoodDiDi_wtqn": "DiDi Food | DiDi Repartidor. Disfruta tu comida cuando quieras, donde quieras.",
  "Gattaran_0_If_you_xGEs": "Uno o más campos están vacíos. Revisa e inténtalo de nuevo, por favor.",
  "FoodC_edit_dECN_fkIy": "Encontrarse fuera del edificio de oficinas",
  "FoodOpB_crm_Takeaway_mode_UxEG": "Modo de entrega",
  "FoodC_202408_tJIe_WbFo": "Cancelar",
  "Gattaran_workstation_zYPi_OfrB": "Valor objetivo",
  "FoodB_2__CkLu": "La misma ciudad",
  "FoodB_resivion_Inaccurate_information_dmRA": "¿Hay alguna información incorrecta?",
  "FoodC_page__KWIm": "Aceptar",
  "FoodB_20260130_eQWh_Vvub": "Optimizar el manejo de la agenda y la ruta",
  "FoodB_subsidy_tVNZ_GHKr": "Recordatorio",
  "FoodB_0905__Uuug": "Reglas del diagnóstico",
  "FoodC_sidebar_Update_successfully_cuyI": "Actualización completada",
  "FoodB_process_eAKS_LYXf": "Rechazado",
  "FoodC_20240607_RSyh_XJnN": "Por favor, abre el enlace en tu dispositivo móvil",
  "Gattaran_Visit_VrZq_Dgvh": "Oportunidades adicionales",
  "Gattaran_0_Visit_Registration_AZYL": "Info. de la tienda",
  "Gattaran_0_Increase_social_MxxK": "Imagen para redes sociales",
  "FoodB_20260130_gEaG_lLwE": "Resolución de acuerdos y objeciones",
  "FoodB_20260130_xZuv_HObe": "Reforzar las habilidades de negociación",
  "Gattaran_Optimization_IGsH_WCQM": "Abrir en DiDi Food",
  "FoodB_V1_toMO_YDdz": "Tareas regulares",
  "Gattaran_v2_LSlZ_XduF": "Toca para conocer las reglas y ayudar a la tienda a convertirse en una tienda {{DiDi_Top}}",
  "FoodB_0623_Indicators_auar": "KPI",
  "Gattaran_center__HcEx": "Todos los mensajes se marcaron como leídos",
  "FoodB_model20250116_GjAr_XZPC": "Hora de ingreso",
  "Gattaran_0__mpop": "Ábrelo en la aplicación o busca \"Gattaran&Explorer feedback\" en D-Chat para ingresar al grupo de retroalimentación",
  "FoodB_APP_WsXR_yQpy": "Inversiones",
  "FoodOpB_Translation_Legal_persons_RduO": "Persona jurídica",
  "FoodC_20240607_wWhy_deWR": "Por favor, actualiza la página y vuelve a intentarlo",
  "Gattaran_management_WVOf_JOti": "Ver",
  "FoodB_1106_kpYX_BXVq": "Analizar",
  "Gattaran_optimation_MQrO_OvRt": "¿Deseas recuperar esta página?",
  "Gattaran_resivion_More_KTYU": "Más",
  "Gattaran_B86_AQDt_AMVU": "Tasa de cancelación de pedidos cancelados por la tienda en {{number}}",
  "FoodC_switch_TFwP_lxTd": "Agradecimiento predeterminado",
  "FoodB_tasktoteams_aXrr_bgrl": "Pedidos diarios completados (servicio de pedidos propio)",
  "Gattaran_V1_ZDXa_aTjw": "Lista de promociones válidas",
  "FoodB_0905__uatF": "Mayor que {{number_or_rate}} tiendas cercanas",
  "FoodB_20260130_KYcL_KXQE": "Casi siempre",
  "Gattaran_202406_IIUg_NlxT": "Información de la tienda",
  "FoodC_edit_wBJW_yfSo": "Departamento",
  "FoodC_20240607_aOOB_RMKm": "Pago en efectivo no disponible temporalmente",
  "FoodB_20250414_QcoH_HIDg": "Total de usuarios",
  "Gattaran_202406_htDL_CJTB": "Creador de la tarea",
  "FoodB_0905__kaPI": "Calificación del diagnóstico",
  "FoodB_20260130_FbBo_MxTb": "El BD investigó previamente la situación actual de sus Rs a visitar (competencia, métricas, precios, etc.)",
  "Gattaran_0__tWkQ": "Productos en promoción",
  "FoodB_ads_WAjG_IoqX": "Anuncio",
  "Gattaran_Optimization_cVHJ_PCUb": "Ver detalles del horario de atención de la tienda",
  "soda-c-i18n---送您%s张免配送费券；": "te daremos %s cupón para un envío gratis;",
  "FoodB_supplement_Network_connection_RVcl": "Falló la conexión. comprueba tu configuración de red",
  "FoodB_tagging_You_chose_tIKm": "Decidiste invalidar este socio potencial por el siguiente motivo: \"La tienda no existe\". Para hacerlo, debes estar a menos de {{distance}} de la tienda. Verifícalo e inténtalo de nuevo.",
  "FoodB_task_idjV_gpOC": "Tarea ejecutada",
  "Gattaran_add_xwYd_UfEG": "Logo",
  "FoodC_20240607_eLRx_hJRj": "Página no disponible en computadoras",
  "Gattaran_Gattaran_wHVV_MQDY": "Tipo de plan",
  "FoodB_20260130_HUuq_fjkk": "Sin calificación",
  "Gattaran_0_Contrast_the_YwEa": "Tener los mismos precios que Mr Black & Mr Pink",
  "FoodC_edit_Hxmm_vrkU": "Edificio residencial",
  "Gattaran_V1_gCzF_PJKj": "{{num}} promoción/promociones a realizar seguimiento",
  "FoodB_tasktoteams_FSIB_Lmdl": "Enlace al menú de {{Rappi}}",
  "FoodB_communications_ZlRD_aGjm": "día(s) faltante(s)",
  "Gattaran_opt_xawD_vBtI": "Horas diarias en línea",
  "FoodB_20260130_dkze_tLMR": "El BD tiene claros los objetivos de las visitas asociadas",
  "FoodB_0617_UUYe_lgPA": "Porcentaje de tarifa de servicio de la competencia - R",
  "FoodOpB_1_Visit_dXVU": "Visitar",
  "FoodB_0617_JNlE_tpzR": "Porcentaje de tarifa de servicio de la competencia - U",
  "FoodB_leads_The_relationship_jkYA": "Hora ideal para contactar",
  "Gattaran_form_KjAJ_bymE": "Ver los detalles del plan",
  "FoodB_20260130_gMyi_nxVp": "Cierre efectivo",
  "Gattaran_BDapp_Pder_myCx": "BD Portal (CKA)",
  "FoodD_suspensionpage_In_the_zGEU": "No hay más resultados",
  "FoodC_202408_AFKG_hWIj": "Fuera de rango. Favor de cambiar la dirección",
  "FoodB_page_Ejhz_BIgP": "Registrarse",
  "FoodOpB_StoreInput_Store_Information_mIjy": "Información del representante de tienda",
  "FoodB_20260130_YWCI_RTgg": "Mejorar en cierres efectivos",
  "FoodC_perception_Tip_exceeds_VSFf": "El agradecimiento supera el límite",
  "FoodB_V2_Satisfied_with_YFEM": "Satisfecha con la situación actual",
  "FoodB_Translation_vrHE_fstW": "Rectificado",
  "Gattaran_84_eYqA_KQKL": "Fecha y hora en que se produjo la infracción",
  "Gattaran_84_ipYl_XAMQ": "Nombre del firmante",
  "FoodB_group0901_KjSA_JaMq": "Obligatorio",
  "Gattaran_0915__UZgP": "Periodo de cálculo: {{date1_date2}}",
  "FoodB_email_AhaC_FOft": "Otro contacto",
  "FoodB_requirement_aAaC_nmQK": "Horas pico en línea",
  "FoodB_20260130_HZgt_YVcN": "Fórmula = (Calificación de la preparación estratégica + Calificación de la conversación comercial + Calificación de los resultados de la visita) / 3 * 100%",
  "FoodB_tagging_You_chose_lWSH": "Decidiste invalidar este socio potencial por el siguiente motivo: \"No es una tienda de venta minorista\". Para hacerlo, debes estar a menos de {{distance}} de la tienda. Verifícalo e inténtalo de nuevo.",
  "Gattaran_202406_JIgY_duWs": "Recibida",
  "Internal_Tools_0523_ZlFL_LzUJ": "Registrarse",
  "FoodB_1106_UjEj_dsYG": "Cancelar",
  "Gattaran_0_Not_willing_JFcK": "No hay acuerdo",
  "FoodB_model20250116_PRsL_yJEl": "Por favor, elige al menos {{num_required_fields}}",
  "FoodB_20260130_iMSl_cUof": "Manejo de sus KPI y relacionamiento de las métricas del R",
  "Gattaran_84_SZSe_qxUU": "Infracción grave",
  "Gattaran_0__sDLK": "Haz clic en el botón Cargar para ver más tiendas",
  "FoodB_process_fmOQ_ZlAg": "No se encontró ningún producto",
  "FoodB_calculator_QGtY_JOsw": "Inversión de la tienda sobre el descuento total",
  "FoodC_education_Basic_requirements_hIbv": "Reglas para los usuarios con respecto a la entrega",
  "支付方式": "Payment Method",
  "Gattaran_202311_WXzo_Yqns": "Agregar socio potencial válido",
  "FoodOpB_Translation_Tax_ID_yEbh": "Registro Único de Contribuyentes",
  "Gattaran_form_HuGK_YufB": "Editar plan de visita",
  "FoodB_20260130_GcFe_YDVN": "Plan de acción",
  "FoodB_Launch_Illegal_import_jlOS": "Entrada no válida",
  "Gattaran_Collection__kwys": "Ahora puedes navegar a las tiendas en la página del mapa",
  "FoodD_Name_November_BcWL": "Nov",
  "FoodB_GTR_MOcd_Ludv": "KA",
  "FoodB_1106_ocKT_vZHR": "La grabación no puede superar los 2 minutos",
  "Gattaran_0_No_contacts_EeBR": "Sin persona de contacto",
  "FoodB_Wordings_MYHl_FXti": "Selecciona un motivo",
  "Gattaran_opt_FWKd_AEaY": "Haz clic aquí para ingresar la información sobre las operaciones fuera de línea",
  "FoodD_Incentive_In_progress_GNvs": "En curso",
  "Gattaran_84_VVSs_wTou": "Para comer aquí",
  "FoodB_2_Visit_Records_LiJy": "Resumen de visitas",
  "FoodC_edit_fLUx_wHAP": "Ejemplo: “llevo una camisa estampada.” También puedes subir fotos de los alrededores para ayudar al repartidor a entregar tu pedido en el lugar correcto.",
  "FoodB_202204_Order_eJXF": "Pedidos",
  "Gattaran_Visit_Fill_in_aFuS": "Ingresar visita con acompañantes",
  "FoodC_202408_KYqe_yVZD": "Ahora no",
  "FoodB_250430_kaeY_cgas": "Nivel de visita",
  "FoodC_edit_kzdk_yzVc": "Encontrarse en la puerta de mi habitación",
  "FoodB_survey_IegO_JQod": "Demanda de tarjeta de crédito",
  "FoodC_edit_HEFc_Dppo": "Encontrarse fuera de mi edificio residencial",
  "FoodB_store_Order_Coupon_zpSY": "Cupón de reembolso de pedido",
  "FoodB_APP_RDdB_KQgY": "Filtrar promociones de ventas",
  "FoodB_1106_fIyR_ECeB": "Ingresa contenido",
  "Gattaran_visit_opSF_XPmM": "El BD trae objetivos claros a la visita",
  "FoodB_calculator_Vzvw_WmgN": "Método de pago",
  "Gattaran_20240409_JmCU_vNnz": "días después se iniciará el registro",
  "FoodC_202408_IDjR_CbbT": "Aceptar",
  "FoodB_2_Call_visit_NGFu": "Por teléfono",
  "FoodB_I_Cancelled_orders_XeVk": "Pedidos cancelados",
  "FoodC_education_2_Receiving_gFZl": "2. Revisa que la dirección de entrega y el método de contacto que proporciones sean los correctos.",
  "FoodB_1__GxZN": "Últimos 30 días",
  "FoodB_B86_xxgH_gxNC": "No",
  "FoodC_202412_AIDx_XZgz": "Editar dirección",
  "Gattaran_Feedback__amKQ": "Alto",
  "Gattaran_0_Is_it_uBZs": "¿Es una cocina oculta (DK)?",
  "Gattaran_0_Price_of_cdsJ": "Los precios en DiDi contra otras apps son",
  "Gattaran_optimization__HjAa": "Haz clic en el botón Atrás nuevamente para salir del Explorador",
  "Gattaran_form_MglG_FNNK": "Hora de la visita",
  "FoodOpB_Translation_ID_Card_jQZG": "Documento Nacional de Identidad",
  "FoodB_20260130_UPbX_zUEa": "Fortalecer la comunicación y proyección de confianza",
  "Gattaran_management_JcWN_FRMj": "Contrato con la tienda",
  "FoodC_cash_WQNI_uYzC": "Agregar",
  "FoodB_collection_625_System_iWnH": "625 - Régimen de las actividades empresariales con ingresos a través de plataformas tecnológicas",
  "FoodOpB_Org_Edit_Gphm": "Editar",
  "Gattaran_Optimization_ZhGy_ZlOk": "Agregar detalles del horario de atención",
  "FoodB_0919__CONM": "Productos no disponibles",
  "FoodB_1106_CBkZ_uDVO": "¿Cuáles son los próximos pasos?",
  "FoodB_GTR_nRcI_TMWR": "CKA",
  "Gattaran_202406_EMkK_osti": "Tienda",
  "FoodOpB_1_Plan_Nfsn": "En planificación",
  "FoodB_V1_GLnG_kpoL": "Tareas del proyecto",
  "FoodB_Commision_Cancel_wbtQ": "Cancelar",
  "FoodC_education_4_Customers_laxR": "4. Una vez que el socio repartidor llegue a tu ubicación, tendrás 10 minutos para recibir tu pedido.",
  "FoodOpB_Management_You_can_aDLi": "Para crear la tienda nueva de todos modos, haz clic en “solicitar revisión”. Ten en cuenta que la revisión puede tomar hasta 2 días.",
  "FoodC_shop__MWyO": "Límite de compra: {{num}}",
  "FoodB_Translation_ycvD_ntAQ": "Apelación",
  "FoodOpB_Org_Can_not_swrB": "¿Seguro deseas eliminar esto? Esta acción no se puede deshacer.",
  "FoodC_2022__SEQk": "Agradecimiento",
  "FoodB_0622_The_statistical_NUCJ": "Los datos se calculan con base en T+1 y se organizan de acuerdo al volumen de ventas de los productos en los últimos 30 días",
  "Gattaran_opt_OIIn_XXkw": "Ver Auditoría",
  "Gattaran_form_KvgC_Afkb": "Confirmar salida",
  "Gattaran_V1_ZkCf_UOay": "Borrar",
  "FoodC_202410_OFhs_UnlA": "Explorar",
  "Gattaran_Edition_mvmO_sigb": "La fecha seleccionada ya tiene un plan de visita existente. Una vez enviado, el plan de visita anterior se sobrescribirá.",
  "FoodB_0921__iLXg": "Cantidad",
  "Gattaran_20240401_iQeT_rFly": "Gracias por tus comentarios",
  "soda-c-i18n---送您1张%s折扣券；": "te daremos un cupón del %s de descuento;",
  "FoodB_0919__etPs": "Múltiples promociones",
  "FoodB_20260130_wKpl_lEGS": "Preparación y análisis de datos",
  "FoodC_edit_EqUG_FRvo": "Dpto./Piso/Habitación",
  "FoodB_calculator_lSyU_ySZI": "¿La tienda está ubicada en Guanajuato?",
  "FoodOpB_management_Actual_value_dSKC": "Valor final",
  "FoodB_202207_Default_BQmA": "Predeterminado",
  "FoodOpB_app_Collecting_documents_wTBe": "Enviando documentos",
  "FoodB_V2_DQvR_Redp": "Usa la función para compartir en la app de BD.",
  "FoodC_optimization_knQx_VpIr": "Agregar",
  "FoodB_up20241218_dJSA_yyZX": "Confirmar",
  "Gattaran_202406_Rqhc_vORg": "Tareas de la tienda",
  "Gattaran_optimation_uLZP_VtyM": "Volver a abrir",
  "FoodB_20260130_sAvF_Somd": "Calificación de la etapa: resultados de la visita",
  "FoodB_Translation_wHEO_FLQr": "Apelación exitosa",
  "Gattaran_mgt_All_SSzR": "Todo",
  "Gattaran_202406_ObEK_ztcK": "No se completó el cálculo de datos de este KPI. Por favor, vuelve a verificarlo mañana",
  "Gattaran_form_pQiE_NLFe": "Objetivo(s) de la visita recomendado(s) en función del resultado del diagnóstico de la tienda",
  "支付": "Pagar",
  "Gattaran_REGULAR_KZHa_qJOa": "Ingresa un número entero",
  "FoodB_IV_Tips_DFOG": "Alertar",
  "Gattaran_202406_kjmQ_Epeu": "Creada",
  "Gattaran_0_What_are_AWJz": "¿Cuál es la oportunidad más grande en la zona?",
  "FoodB_model20250116_pAHl_Vjqs": "No aprobada",
  "Gattaran_202406_NOiB_wJYW": "Crear tarea",
  "Internal_Tools_Optimization_KJgL_fWkX": "Horario de atención, hoy",
  "FoodB_Analysis_Rise_decline_dZnP": "Incremento:",
  "Gattaran_jumpnewstore_FJjw_JHRB": "Tarea(s) de Impulso para tiendas nuevas completada(s)",
  "Gattaran_Visit_Advantages_CSEp": "Fortaleza",
  "FoodC_Storefront_Fzba_uHgH": "Registro no disponible",
  "FoodC_education_In_the_MKeB": "La cancelación no se considerará responsabilidad tuya en las siguientes situaciones:",
  "FoodB_20260130_HpAF_xVst": "Relacionamiento y empatía con el usuario",
  "FoodC_improve__ovBF": "Porciones pequeñas",
  "FoodB_0617_RqaF_EHZE": "Fecha de vencimiento del contrato de exclusividad con la competencia - U",
  "Gattaran_0__ytbk": "Prioridad",
  "FoodB_audit_New_and_yYux": "Diferencia entre el nombre anterior de la tienda y el nuevo",
  "Gattaran_Visit_Related_Visit_RGas": "Asociar los registros de visitas",
  "Gattaran_side__OvkZ": "Jueves",
  "FoodOpB_tagging_Store_does_sduq": "La tienda no existe",
  "FoodC_education_In_order_AZCw": "Esta reglas se crearon con el motivo de ayudar a que todos los usuarios tengan una buena experiencia con {{brand_name}}. En caso de que haya algún inconveniente relacionado con la entrega, aplicará lo siguiente.",
  "FoodOpB_Gattaran_Reset_ILVf": "Restablecer",
  "FoodB_1106_ZsZM_gMYt": "Por favor, resume con la estructura siguiente",
  "Gattaran_transformation__QWlQ": "Completa todos los elementos obligatorios",
  "Gattaran_0__jRoM": "Abrir D-Chat",
  "FoodB_time_Business_hours_kRTs": "Horario de operación en días feriados",
  "FoodB_1106_vIQn_DUwT": "Alcanzaste el tiempo máximo de grabación de {{max_record_time}} segundos. ¿Comenzar a analizar los datos?",
  "FoodB_0921__kEaD": "Subsidio%",
  "FoodB_20260130_OgUC_hHHH": "Siempre",
  "FoodC_education_Cancellation_Policy_fxrl": "Política de cancelación",
  "FoodB_email_Cebi_VpDl": "Teléfono",
  "FoodB_Analysis_New_customers_vYDl": "Usuarios nuevos",
  "FoodB_up250108_UapS_ZXgM": "Ver ahora",
  "Fintech_Credit_2__TvDQ": "Motivo de cancelación",
  "FoodB_20260130_eCWS_Wotm": "Uso efectivo de herramientas y tecnología",
  "Gattaran_202406_UOFx_ekzp": "Cancelar",
  "FoodB_resivion_Overdue_visit_jTHW": "Visitas vencidas",
  "FoodB_calculator_TJJY_SkoH": "Inversión de la tienda",
  "FoodOpB_CRM_Taxpayer_Address_EBwy": "Dirección del contribuyente (Nacional)",
  "FoodC_202408_YjqN_Yvyz": "Agrega una dirección para ver tarifa y tiempo",
  "FoodOpB_analysis_Performance_analysis_NMbA": "Información de rendimiento",
  "FoodOpB_set_Determination_wYFG": "Aceptar",
  "FoodC_202408_IMjl_ywFc": "Cambiar",
  "Gattaran_System_wrVY_PjDQ": "Nombre del plan",
  "FoodC_202410_pHYX_VjbD": "Cerrar",
  "FoodB_model20250116_TRTm_agBI": "Volver",
  "FoodB_calculator_ydSg_ejbp": "IVA",
  "FoodB_2__FNaI": "La misma zona objetivo",
  "请输入XXXXX-XXX": "Entrar XXXXX-XXX",
  "合同类型": "Tipo de contrato",
  "回收完成": "Devuelto",
  "签约状态": "Estado del contrato",
  "正常经营": "en línea",
  "合作拜访结果": "Resultado de la visita de afiliación",
  "执照照片": "Foto del permiso",
  "重复门店电话": "Teléfono del socio potencial duplicado",
  "暂无合作意愿": "Ninguna intención de cooperación",
  "日常维护信息": "Información de mantenimiento de rutina",
  "签字": "Firma",
  "请选择不合作原因": "Seleccionar razón para no asociarse",
  "首次完单时间": "Hora de finalización del primer pedido",
  "支行号": " ",
  "暂无": "Ninguno",
  "获取商圈中...": "Obteniendo los datos del área objetivo…",
  "周四": "Jue",
  "请在Gattaran上完成撤销申请！": "Completa la solicitud de cancelación en Gattaran.",
  "输入有误": "Ingresado de forma incorrecta",
  "设备信息": "Información del dispositivo",
  "申诉通道": "Presentar apelación",
  "目前营业中门店": "Abiertos actualmente",
  "店主（法人）": "Propietario (representante legal)",
  "未达到任务完成的标准": "Requisitos para completar la tarea no cumplidos",
  "授权书照片": "Foto de la carta de autorización",
  "证号": "N.º de certificado",
  "法人CPF": "CPF contribuyente",
  "工具": "Herramienta",
  "工商登记时间": "Hora de registro comercial",
  "未确定合作": "Asociación no confirmada",
  "Curp号必须为18位字符": "La CURP debe contener 18 caracteres",
  "提交成功": "Se envió correctamente.",
  "公司": "La empresa",
  "驳回原因": "Razones de rechazo",
  "城市": "Ciudad",
  "发放时间": "Asignado en",
  "商机转交": "Lead fuera del área objetivo",
  "保存并发邮件&短信": "Guardar y enviar correo electrónico y SMS",
  "签约授权书": "Autorización de firma",
  "信息已完善": "Información completa",
  "上拉加载更多": "Desliza hacia arriba para cargar más",
  "支付验证未通过": "Error de verificación de pago",
  "等待原因": "Razón para esperar",
  "平台配送及自配送不允许同时选择不支持": "No se puede seleccionar “entrega de plataforma” y “entrega de tienda” a la vez.",
  "平台管控中": "Tienda cerrada por el control del sistema",
  "信心度A": "Nivel de confianza A",
  "信心度B": "Nivel de confianza B",
  "信心度C": "Nivel de confianza C",
  "是": "Sí",
  "同意上线": "Accedió a conectarse",
  "查看更多": "Más",
  "KP CPF": "CPF de persona responsable",
  "评分": "Evaluación",
  "法人名片假名": "Persona jurídica Nombre Katakana",
  "我的拜访": "Mis Visitas",
  "居民证明": "Certificado de residencia",
  "确认签章": "Verificar y firmar",
  "合作拜访": "Visita para afiliación",
  "拜访记录": "Información de la cita",
  "无合作意向": "No tiene interés en asociarse",
  "PAD型号": "Modelo de tableta",
  "乙方名称片假名": "Nombre del Restaurante Katakana",
  "开户行": "Banco emisor",
  "点击收起": "Colapso",
  "暂停营业中": "Tienda cerrada temporalmente",
  "周日": "Dom",
  "已关闭": "Cerrado",
  "CNPJ": "CNPJ",
  "KP姓片假名": "Apellido KP Katakana",
  "有效": "Sí",
  "CKA BD": "CKA BD",
  "确定删除吗？": "¿Confirmar eliminación?",
  "日常工具": "Herramientas diarias",
  "正常": "Normal",
  "掉线中": "Tienda desconectada",
  "沟通经营问题（服务管控+店铺装修）": "Analizar las cuestiones operativas (control de servicio + decoración de la tienda)",
  "梅斯卡尔酒": "Mezcal",
  "帐户持有人CPF": "CPF del titular de la cuenta",
  "商户运营": "Compromiso",
  "菜单照片": "Foto del menú",
  "去设置": "Configuración",
  "跟进中": "Siguiendo",
  "销量(单/周)：": "Ventas(Pedidos por semana): ",
  "支持以下哪种支付方式": "¿Que métodos de pago acepta la tienda?",
  "失败号": "N.º de desaprobación",
  "谷歌地图": "mapa de google",
  "打开浏览器失败": "No se puede abrir el navegador",
  "银行卡号仅支持数字输入": "El número de la tarjeta bancaria solo pueden contener números",
  "佣金补贴周期": "Ciclo de recompensa de comisión",
  "沟通新店保护设置": "Explicar cómo crear un nuevo impulso para la tienda",
  "公共契约编号": "N.º de contrato público",
  "首次完成开店检查时间": "Hora de finalización de la primera revisión de la tienda",
  "已签约": "Firmado",
  "商家概况": "Resumen de la tienda",
  "执行团队": "Equipo responsable",
  "未连接到服务器": "No se puede conectar al servidor",
  "KP CPF照片": "Foto del KP CPF",
  "自配送起送费": "Tarifa mínima de entrega directa",
  "电话号码不对": "Número de teléfono incorrecto",
  "我知道了": "Entendido",
  "考虑中": "Lo está considerando",
  "Curp号": "N.º de CURP",
  "已归档": "Archivado",
  "是否需要pad": "se necesita pad",
  "点击校准": "Haz clic para ajustar",
  "附件照片": "Archivo adjunto (foto)",
  "%s级": "%s Nivel",
  "人工标记平台：": "Anual: ",
  "审核通过商户数": "Tiendas aprobadas",
  "老版无Curp": "versión antigua sin CURP",
  "首页": "Inicio",
  "商机无效": "Socio potencial inválido",
  "未完成": "No finalizada",
  "支付验证": "Verificación de pago",
  "返回": "Atrás",
  "账号无法登陆": "No puedo iniciar sesión",
  "纳税照片": "Archivo adjunto (foto)",
  "建议拍摄店面照片": "Se recomienda tener fotos de la entrada de la tienda",
  "标题": "Título",
  "不承诺": "Sin compromiso",
  "不能超过%d字": "No puede exceder de %d caracteres",
  "佣金补贴比例": "Porcentaje de recompensa de comisión",
  "放弃": "Descartar",
  "请选择营业天数": "Seleccionar días de apertura",
  "KP名": "Nombre KP",
  "单次最大扣费金额": "Monto máximo para un solo pedido",
  "持卡人姓": "Apellido del titular de la tarjeta",
  "请输入门店ID": "Ingrese el ID de la tienda",
  "售卖时间": "Horas de trabajo",
  "是否有异常标签": "¿Con etiquetas incorrectas?",
  "是否有违规记录": "¿Hay algún registro de violación?",
  "审批通过": "Pasó la auditoría",
  "上传最大数量为%d张，图片上限为5MB": "Tamaño máximo del archivo 5 MB, se puede subir hasta %d imágenes",
  "银行代理number": "Banking Agency Number",
  "地区": "Región",
  "门店logo": "Logotipo de la tienda",
  "商家不愿培训": "La tienda no está dispuesta a recibir capacitación",
  "审核中商户数": "Tiendas en verificación",
  "银行": "Banco",
  "已完成设置": "Configuración finalizada",
  "已添加": "Añadido",
  "复制成功": "Copiado",
  "愿意改善": "Dispuesta a hacer mejoras",
  "首次有效上线时间": "Hora de la primera validación electrónica",
  "My Number卡": "Mi tarjeta de número",
  "设备回收": "Devolución del dispositivo",
  "补充照片": "Otras fotos de referencia",
  "再次尝试电话联系": "Contactar a la tienda de nuevo",
  "填写拜访": "Ingresar detalles de la visita",
  "门店POI不能为空": "Ubicación de la tienda no puede quedar vacío",
  "商机信息": "Información de Lead",
  "Pad": "Pad",
  "经营状态": "Estado operacional de la tienda",
  "与KP完成沟通即视为有效拜访": "Fue productivo visitar y conversar con el Representante de la tienda",
  "快速拍摄": "Agregar o ver fotos en sistema",
  "设备故障": "Fallo del dispositivo",
  "菜单信息": "Información del menú",
  "出生日期": "Fecha de nacimiento",
  "自配送费": "Tarifa de entrega directa",
  "（创建超级管理员账号）": "（Crear cuenta de superadministrador）",
  "请输入": "Especifica",
  "法人姓": "Persona jurídica Apellido",
  "朗姆酒": "Ron",
  "合同记录": "Registros del contrato",
  "待办任务": "Tareas Pendientes",
  "（商家接收邮件）": "（Dirección de correo electrónico de la tienda）",
  "已首次上线商户数": "Número de las tiendas que han estado online por primera vez",
  "不想使用外卖模式": "No quiere usar el modo de entrega",
  "一般酒精产品贩卖准证": "Permiso general de venta de productos alcohólicos",
  "请选择": "Selecciona",
  "营业时间段不能重叠": "No se puede confugurar el mismo horario comercial",
  "有特殊情况不能上线": "No puede conectarse debido a circunstancias especiales",
  "门店PAD信息": "Información de la tableta de la tienda",
  "商户调研": "Encuesta a la tienda",
  "葡萄酒": "Vino",
  "推迟": "Pendiente",
  "再次申请": "Volver a solicitar",
  "自配送佣金比例": "Cuota de Servicio（Entrega Propia）",
  "门店地址": "Dirección",
  "推荐完成": "Tareas sugeridas a completar",
  "拜访内容": "Tipo de visita",
  "活期": "Cuenta corriente",
  "创建时间": "Creado en",
  "过期拜访": "Visita después de expiración",
  "刷新成功": "Actualizado correctamente",
  "解约": "Finalizar contrato",
  "价格承诺": "El precio prometido",
  "电子合同": "Contrato electrónico",
  "KP电话": "Teléfono del representante de la tienda ",
  "不愿配合": "No está dispuesta a colaborar",
  "银行流水单": "Estado de cuenta",
  "是否需要拍照": "¿Es necesario tomar una foto?",
  "请输入13位有效数字": "Escribe un número de 13 dígitos válido",
  "LTE": "LTE",
  "PAD领取人": "Destinatario de la tableta",
  "银行名称": "Nombre del banco",
  "确定": "Cambiar",
  "金额": "Total",
  "待领取": "No reclamado",
  "停止营业": "Detener operaciones",
  "合作谈判": "Negociaciones comerciales",
  "KP姓名:": "Nombre del representante de la tienda: ",
  "商机详情": "Editar Lead",
  "信息未完善": "Información incompleta",
  "CPF": "CPF",
  "查看": "Ver",
  "证件照片": "Foto de Id.",
  "税号": "N.º de identificación fiscal",
  "促进商户首次上线": "Animar a la tienda a conectarse por primera vez",
  "语言": "Idioma",
  "登录商户账号": "Iniciar sesión en la cuenta de la tienda",
  "未联系到关键目标": "No se pudo contactar a las personas clave",
  "任务类型": "Tipo de tarea",
  "打款授权书": "autorización de pago",
  "营业时间": "Período de actividad del socio potencial",
  "电话培训": "Capacitación por teléfono",
  "联系不上": "No se pudo contactar",
  "编辑商机": "Editar socios potenciales",
  "拜访时间": "Fecha",
  "纸质合同": "Copia impresa",
  "保存草稿": "Guardar borrador",
  "账号": "Número de cuenta",
  "接收人": "Destinatario",
  "円": "円",
  "无多余人力(过于繁忙)": "No hay suficientes empleados (demasiado ocupados)",
  "预计参加：店铺配置": "Está pensando en participar: configurado por la tienda",
  "WIFI": "WIFI",
  "无效": "No efectivo",
  "应上线商户数": "Tiendas que deben llevarse en línea",
  "结算信息": "Información de establecimiento",
  "(R$)": "(R$)",
  "关于": "Acerca de",
  "设置": "Configuración",
  "担心配送质量": "Preocupado por Calidad de entrega",
  "数值只能是%s位小数": "Debe redondearse a %s decimales",
  "CKA": "CKA",
  "录入合同基础信息": "Ingresa la información básica del contrato",
  "未见KP": "No se puede contactar DM",
  "不参加": "No participará",
  "不保存": "Rechazar",
  "酒精销售许可证": "Licencia de bebidas alcohólicas",
  "手机号": "Número de teléfono celular",
  "疑似KA": "KA prevista",
  "是否有效拜访": "¿La visita fue productiva?",
  "完成培训": "Capacitación finalizada",
  "请输入有效的门店id": "Ingrese un ID de tienda válido",
  "持卡人姓名": "Nombre del titular de la tarjeta",
  "系统标记平台：": "Auto: ",
  "其他": "Otros",
  "人工标记平台": "Anual",
  "品牌名称": "Nombre de la marca",
  "选择日期": "Seleccionar fecha",
  "必须为%d或%d字": "Debe contener %d o %d caracteres",
  "重复门店ID": "Id. de tienda duplicado",
  "工商登记注册地": "Dirección de registro comercial",
  "白兰地": "Brandy",
  "数据": "Datos",
  "复制": "Copiar",
  "商户签约": "Incorporación",
  "乙方邮箱": "Buzón de la parte B",
  "无营业资质": "Faltan certificados y documentos del negocio",
  "活跃程度": "aktiva nivelo",
  "找不到店": "No se puede localizar",
  "提交开店申请商户数": "Tiendas con solicitudes de firmar",
  "不合作原因": "Razón para no asociarse",
  "关联品牌名称": "Nombre de la marca relacionada",
  "门店距离": "Distancia de la tienda",
  "门店名称": "Nombre de la tienda",
  "陪访人": "Personas que acompañan al representante DiDi en la visita",
  "银行账户digit": "Dígito de la cuenta bancaria",
  "营业时间不能重复设置": "no se puede repetir configuración del horario comercial",
  "纳税信息": "Información fiscal",
  "完善以下": "Completa los siguientes campos",
  "乙方联系人手机": " ",
  "30天后解约": "Contrato terminado después de 30 días",
  "上传照片不能超过%dMB，请重新上传": "El tamaño de archivo de imagen no puede exceder %d MB. Cárgalo de nuevo",
  "电话支持字符：数字、英文逗号，录入其他符号，不允许提交": "Caracteres admitidos para los números de teléfono: números y comas (no se podrá enviar si se ingresa otro tipo de carácter)",
  "您当前的网络环境不太好": "Su entorno de red actual no es muy bueno",
  "审核失败": "Rechazdo/a",
  "模式选择": "Seleccionar formato del contrato",
  "商圈": "Área objetivo",
  "类型": "Tipo",
  "启动费太高": "Tarifa inicial muy alta",
  "加价限制": "Incremento máximo al precio",
  "获得初步意向": "Mostró interés al principio",
  "任务ID": "ID de la tarea",
  "不确定合作意向": "El interés en la cooperación no está confirmado",
  "添加营业时间": "Agregar horario de operación",
  "CNPJ号必须为14位数字": "El CNPJ debe ser un número de 14 dígitos",
  "请输入半角片假，不能超过48个字符": "Ingrese katakana de ancho medio, no puede exceder de 48 caracteres",
  "回收pad": "Devolver tableta",
  "商家信息": "Información de la tienda",
  "自配送范围及时长": "Rango y tiempo de entrega directa",
  "市政经营许可证": "Licencia comercial municipal",
  "至": "a",
  "图片": "Imagen",
  "未完善": "No finalizada",
  "打烊中": "Tienda cerrada",
  "菜单": "Administrar menú",
  "下一步": "Siguiente",
  "正式拜访": "Visita programada",
  "具备上线能力": "Listo en línea",
  "金额(MX$)": "Total (MX$)",
  "平台配送最低服务费": "Tarifa de servicio mínima",
  "系统标记平台": "Auto",
  "请选择无效拜访原因": "¿Por qué no fue productiva la visita?",
  "过于繁忙": "Demasiado ocupados",
  "日本": "Japón",
  "若证件类型选择“老版无Curp”，需上传补充附件": "Si se selecciona el tipo de Id. ”Versión antigua sin CURP“, se debe cargar un archivo adjunto complementario",
  "拜访方式": "Método de visita",
  "选择城市": "Seleccionar la ciudad",
  "退出登录": "Cerrar sesión",
  "日常提醒商家上线": "Recordatorio de rutina para que la tienda se conecte",
  "回收未完成": "No devuelto",
  "上传最大数量为1张，图片上限为5M": "Tamaño máximo del archivo 5 MB, máximo 1 imagen",
  "千": "mil",
  "签约%d周后": "%d semana(s) después de firmar",
  "乙方联系人CPF": "Restaurante Contacto CPF",
  "照片": "Foto",
  "法人姓名": "Representante Legal",
  "营业信息": "Información del negocio",
  "添加电话": "Añadir número de teléfono",
  "打开地图失败": "No se puede abrir el mapa",
  "商家位置": "Ubicación de la tienda",
  "开始扣费时间": "Hora inicial de deducción",
  "我负责的": "Supervisado por mí",
  "平台配送": "Plataforma de entrega",
  "KP邮箱": "Correo electrónico del representante de la tienda",
  "封禁": "Suspensión",
  "合同信息": "Información del contrato",
  "卫生安全通知": "aviso de operación (saneamiento)",
  "账号名称": "Nombre de cuenta",
  "现金支付": "Pago en efectivo",
  "座机": "Teléfono fijo",
  "乙方联系人CPF照片": "CPF Restaurant Contact Foto de CPF",
  "许可证有效期": "Vigencia del permiso",
  "还在考虑，需要追客": "Todavía lo está considerando, es necesario hacer un seguimiento con el cliente",
  "支行名称": "Nombre de la sucursal bancaria",
  "门店ID": "Identificación de la tienda",
  "提交材料": "Enviar documentos",
  "失败原因": "Motivo de desaprobación",
  "无法联系到KP": "No es posible contactar KP",
  "授权人": "Nombre del director",
  "手机": "Celular",
  "请输入XXX-XXXX": "Especifica XXX-XXXX",
  "我的新增": "Reciente",
  "KP名片假名": "Nombre KP Katakana",
  "没联系到": "No se pudo contactar",
  "不需要": "No",
  "已拜访商机数": "Tiendas visitadas",
  "仅支持数字输入": "Solo puede incluir números",
  "铺设失败": "Error",
  "任务完成": "Tarea finalizada",
  "复制链接": "Copiar link",
  "已完成": "Completado",
  "草稿中": "Borrador",
  "否": "No",
  "商户主体类型": "Información Corporativa",
  "经营品类": "Categoría del Lead",
  "待定": "No seguro",
  "完单量": "Pedidos completados",
  "担心外卖模式(不想使用外卖模式)": "Preocupación por el uso del modo de entrega (no desea utilizarlo)",
  "乙方注册地址邮编": "Dirección registrada de la Parte B",
  "营业执照": "Licencia comercial",
  "账户余额：": "Monto de la cuenta: ",
  "结算信息照片": "Foto de Pago",
  "价格信息": "Información de precios",
  "证件类型": "INE/INF",
  "威士忌": "Whisky",
  "在线": "En línea",
  "销售姓名": "Representante de DiDi",
  "合同照片": "Foto del contrato",
  "龙舌兰酒": "Tequila",
  "编辑商机成功": "Datos de prospecto editados correctamente",
  "拜访对象": "Persona a visitar",
  "营业中": "Tienda abierta",
  "请输入数字": "Por favor ingrese numeros",
  "全部": "Todos",
  "取消订单量": "Pedido cancelado",
  "电话": "Llamar",
  "请输入门店名称搜索": "Ingrese el nombre de la tienda",
  "当前门店总数": "Número total de tiendas",
  "已签约商户数": "Tiendas contratadas",
  "日常维护": "Mantenimiento de rutina",
  "合同版本": "Versión del contrato",
  "商机价值": "Rango de clientes potenciales",
  "联系方式": "Información de contacto",
  "管控状态：": "Estado de control: ",
  "审批中": "En revisón",
  "拜访目标": "Motivo de la visita",
  "门店类型": "Tipo de tienda",
  "创建成功": "Creado",
  "账户类型": "Tipo de cuenta",
  "KA BD": "KA BD",
  "门店名称片假名": "Nombre de la tienda Katakana",
  "乙方注册地址片假名": "Domicilio Katakana",
  "对私": "Privada",
  "个人企业": "Empresario individual",
  "订单均价": "Precio promedio de pedido",
  "需要完善": "El formulario está incompleto",
  "撤销申请": "Solicitud de cancelación",
  "请先输入门店地址": "Primero, ingresa la dirección de la tienda",
  "默认": "Predeterminado",
  "请补全营业时间": "Agregar horas de apertura",
  "校准POI": "Ajustar coordenadas",
  "全部门店": "Todas las tiendas",
  "不支持": "No",
  "暂停经营": "Cerrada temporalmente",
  "添加营业时间段": "Agregar horario",
  "合同基础信息": "Información básica del contrato",
  "请输入5位有效数字": "Escribe un número de 5 dígitos válido",
  "提交审批后，在审批过程中信息不可修改，是否确认提交？": "Recordatorio: no se puede modificar la información después de enviarla para su aprobación. ¿Quieres continuar con el envío?",
  "证件号": "N.º de identificación",
  "有限责任公司": "Personas Jurídica - Sociedad de Responsabilidad Limitada",
  "长期有效": "eficaz a largo plazo",
  "乙方注册地址": "Dirección registrada del tercero",
  "饮料店期间限定酒品贩卖准证": "Permiso limitado de venta de licor durante la tienda de bebidas",
  "请录入关闭原因": "Rellene un motivo de cancelación, por favor",
  "土地使用许可证": "Permiso de uso de suelo",
  "重复门店": "Duplicado",
  "普通商家": "Tienda estándar",
  "距离": "Distancia",
  "不小于%d": " no menos que %d",
  "不愿完成": "No está dispuesta a finalizarla",
  "推迟发放": "Concesión pospuesta",
  "必须为%d字": "Debe contener %d caracteres",
  "担心外卖模式": "No confia en plataformas de entrega",
  "当该餐厅存在多个经营者时，此处必须填写合同签署人或授权合同签署人姓名": "Si un restaurante tiene varios operadores, aquí se deben ingresar los nombres de todos los agentes autorizados o signatarios del contrato.",
  "提交成功！": "Se envió correctamente.",
  "未完成PAD发放": "Concesión de tabletas no finalizada",
  "有效商机数": "Prospectos efectivos",
  "无相关信息": "No hay datos disponibles",
  "查看拜访记录": "Ver historias de visitas",
  "抽佣：": "Comisión: ",
  "删除": "Eliminar",
  "银行卡号": "CLABE",
  "其他信息": "Otra información",
  "起始时间": "Fecha de inicio",
  "预计进行改善": "Está pensando en hacer mejoras",
  "不愿改善": "No está dispuesta a hacer mejoras",
  "签约数据": "Datos de Convenios",
  "登记簿照片": "Foto de Registrarse",
  "电销团队": "Equipo de telemercadeo",
  "完成时间": "Completado en",
  "放弃原因": "Motivo del descarte",
  "KP电话:": "Teléfono del representante de tienda: ",
  "完成PAD发放": "Concesión de tabletas finalizada",
  "完成工作": "Completar trabajo",
  "提交中": "En progreso",
  "营业时间段": "Horas de apertura",
  "任务完成标准": "Requisitos para completar la tarea",
  "商户官网": "Sitio web oficial del comerciante",
  "门脸照片": "Foto del exterior de la tienda",
  "门店电话:": "N.º de teléfono de la tienda: ",
  "新建商机成功": "Se agregó un nuevo prospecto correctamente",
  "添加拜访计划": "Agregar planes de visitas",
  "营业执照照片": "Foto de Licencia comercial",
  "驾照": "Licencia de conducir",
  "个人信息": "Mi perfil",
  "订单量": "Pedidos",
  "董事": "Director",
  "有效期": "Periodo de vigencia",
  "周三": "Mié",
  "高端饭店": "Concept",
  "是否已经加入其他外卖平台？": "¿La tienda trabaja con otra plataforma de entrega?",
  "周一": "Lun",
  "点击查看原因": "Ver detalles",
  "去修改": "Modificar",
  "KP电话是店长账户": "El teléfono KP es la cuenta de administrador",
  "确认要清空搜索记录吗？": "¿Borrar el historial de búsqueda?",
  "状态机": "Máquina de estados",
  "暂无数据": "No hay datos",
  "拜访详情": "Cita",
  "启动费": "Tarifa de activación",
  "疑似CKA": "CKA prevista",
  "选择职位": "Seleccionar cargo",
  "提交人": "Candidato",
  "签约信息": "Detalles del contrato",
  "审核中": "En revisón",
  "请输入半角片假名": "Ingrese katakana de ancho medio",
  "请选择无意愿原因": "Especifica el motivo de la falta de interés",
  "（多选）": "(seleccionar múltiples)",
  "上一步": "Anterior",
  "周五": "Vie",
  "执行人": "Asignado a",
  "填写拜访备注可供后续跟进参考": "Agrega comentarios; puedes incluir los puntos de seguimiento de la visita",
  "扣费次数大于等于1": " ",
  "线下": "Presencial",
  "效率": "Eficiencia",
  "无效商机": "Socio potencial inválido",
  "拜访历史": "Bitácora de visita",
  "封禁中": "Suspendida por la plataforma",
  "原因": "Motivo",
  "CPF号必须为11位数字": "El CPF debe ser un número de 11 dígitos",
  "周二": "Mar",
  "保存": "Guardar",
  "商户号": "Numero de comerciante",
  "参加": "Participará",
  "万": "Diez mil",
  "乙方联系方式": "Celular",
  "加价限制（%）": "Incremento máximo al precio(%)",
  "上传交付照片": "Cargar foto de la entrega de la tablet",
  "商户主体类型为公司时需提供此项内容": " ",
  "编辑经营信息": "Editar datos de operaciones",
  "开户公司CNPJ": "CNPJ de la compañía que abre la cuenta",
  "门店信息": "Información de la tienda",
  "当前数据计算至:": "Datos actuales actualizados a: ",
  "店长": "Gerente de la tienda",
  "已完成培训": "Capacitación finalizada",
  "不限": "Sin límite",
  "品牌授权书": "autorización de marca",
  "P1": "P1",
  "请输入3位有效数字": "Escribe un número de 3 dígitos válido",
  "P0": "P0",
  "P2": "P2",
  "转让": "Cambio de dueños",
  "自入驻": "Registrado por el",
  "老版有Curp": "versión antigua con CURP",
  "店内环境": "Foto del interior de la tienda",
  "详细原因": "Motivo detallado",
  "金酒": "Gin",
  "请输入7位有效数字": "Escribe un número de 7 dígitos válido",
  "签字授权书": "Autorización de firma",
  "无效原因": "Razón de la invalidez",
  "持卡人地址": "Dirección de la cuenta bancaria",
  "拜访备注": "Observaciones de la visita",
  "标记问题门店": "Reportar un problema en la tienda",
  "已完善": "Finalizada",
  "指定": "Determinado",
  "发起者": "Iniciador",
  "抽佣问题": "Tarifa de servicio muy alta",
  "合法代表": "Representante legal",
  "自定义": "Personalizar",
  "店铺主体类型是法人时必填（13位数，国税厅公布的法人号码）": "Se requiere si el tipo de cuerpo principal de la tienda es una persona jurídica (13 dígitos, número de persona jurídica anunciado por la Agencia Tributaria Nacional)",
  "单次最大扣费金额(MX$)": "Monto máximo para un solo pedido (MX$Y)",
  "重复门店名称": "Nombre del socio potencial duplicado",
  "KP姓名": "Nombre del representante de la tienda ",
  "IMEI": "IMEI",
  "负责人表示不合作": "La persona a cargo no se mostró interesada en colaborar",
  "去升级": "Actualizar",
  "将本页截图发送至didi@didichuxing.com;总部进行人工线下校验，并在7日内反馈申诉结果;": "Envía una captura de pantalla de esta página a didi@didichuxing.com. La sede central la inspeccionará manualmente y responderá la apelación en un período de 7 días",
  "银行代理digit": "Dígito de la agencia bancaria",
  "巴西": "Brasil",
  "捡入": "Obtener",
  "线上支付": "Pago en línea",
  "竞品独家签约": "Contrato exclusivo con el competidor",
  "总评价人数": "Número de evaluadores",
  "周六": "Sáb",
  "门店电话": "Teléfono de la tienda",
  "标红信息即可完成添加": "Completa todos los campos marcados en rojo",
  "疑似CKA/KA": "CKA/KA prevista",
  "执行者": "Asignado a",
  "法人CPF照片": "Foto de CPF del representante legal",
  "待办事项": "Tareas pendientes",
  "预计休业": "Está planificando el cese de las operaciones comerciales",
  "其他筛选": "Otros Filtros",
  "是否自配送：": "Entrega en tienda: ",
  "当前定位失败": "Posicionamiento fallido",
  "优先级": "Prioridad",
  "任务来源": "Origen de las tareas",
  "可提现金额：": "Cantidad que puede retirarse(MX): ",
  "自配送订单量（单/周）": "Self delivery Numero de ventas diarias(Pedidos por semana)",
  "审核完成": "Verificación finalizada",
  "店员": "Empleado",
  "冻结金额：": "Fondos congelados(MX): ",
  "签约状态：": "Estado de firma: ",
  "时间格式错误": "Error de formato de hora",
  "审批失败": "Rechazdo/a",
  "确定合作": "Asociación confirmada",
  "啤酒": "Cerveza",
  "接收电子合同的邮箱": "Buzón para recibir contrato electrónico",
  "门店照片": "Foto de la tienda",
  "电话预约": "Programar una visita",
  "选择商圈": "Seleccionar área objetivo",
  "KA": "KA",
  "结束时间": "Hora final",
  "确认银行卡号": "Confirmar cuenta bancaria",
  "在留卡": "Tarjeta de residencia",
  "访谈&调研": "Entrevista y encuesta",
  "承诺": "Con compromiso",
  "实际上线商户数": "Tiendas realmente en línea",
  "暂不支持复制功能": "Función Copiar no disponible",
  "不能为空": "No puede quedar vacío",
  "暂停营业": "Cerrada temporalmente",
  "提案失败": "La presentación no tuvo éxito",
  "经营信息": "Datos de operaciones",
  "依据门店POI反解": "Según las coordenadas de la tienda",
  "拜访结果": "Ver resultado",
  "乙方联系人姓": "Información de contacto de la otra parte Apellido",
  "银行卡号必须为18位": "El número CLABE debe contener 18 dígitos",
  "储蓄": "Caja de ahorro",
  "首位必须是1，必须输入11位": "El primer digital debe ser 1 y debe estar en 11digital",
  "无银行账号": "Sin cuenta bancaria",
  "KP所属部门": "departamento de kp",
  "成功留存": "Retenido correctamente",
  "伏特加": "Vodka",
  "暂时不愿上线": "No está dispuesta a conectarse en este momento",
  "沟通经营问题": "Analizar las cuestiones operativas",
  "支持": "Sí",
  "请输入正确的邮箱地址": "Ingresa un correo electrónico válido",
  "确认要退出吗？": "¿Deseas cerrar sesión?",
  "乙方联系人": "Contacto de la parte B",
  "公证编号和地区": "Región y número de notario",
  "后续陌拜": "Posterior llamada en frío",
  "持卡人名": "Nombre del titular de la tarjeta",
  "通过时间": "Hora de aprobación",
  "请输入银行名称或五十音": "Ingrese banco beneficiario",
  "指已签约并且上线接单的门店": "Se refiere a las tiendas que firmaron un contrato y ya están aceptando pedidos",
  "线下店铺菜单": " ",
  "无多余人力": "Falta capacidad",
  "格式错误": "Error de formato",
  "合同生效日期": "Fecha de vigencia del contrato",
  "分发失败": "Asignación fallida",
  "使用此功能需升级至最新版本": "Para acceder a esta función, deberás actualizar a la última versión",
  "任务分发": "Asignar tarea",
  "乙方联系人名片假名": "Información de contacto de la otra parte Nombre Katakana",
  "ESC": "ESC",
  "无法获取手机定位，请检查": "No se pudo obtener la ubicación del teléfono. Compruébala",
  "上传最大数量为3张，图片上限为5M": "Tamaño máximo del archivo 5 MB, se puede subir hasta 3 imágenes",
  "佣金审核证明": "Certificado de la revisión de recompensa",
  "范围": "Zona",
  "公司公证": "certificados de empresa",
  "审核通过": "Pasó la auditoría",
  "查看申请": "Ver solicitud",
  "未签约": "Sin firmar",
  "申请签约": "Solicitar firma",
  "已校准": "Coordenadas guardadas",
  "审核结束": "Resultados de la verificación",
  "具备上线能力商户数": "Tiendas listas para llevarse online",
  "邮编": "Código postal",
  "手机和座机都只支持10位数字": "Lo números de teléfono móvil y de línea deben tener 10 dígitos",
  "不允许特殊字符": "No puede contener caracteres especiales",
  "KP姓": "Apellido KP",
  "店内桌数（桌）": "Conteo de mesas(Mesas)",
  "待提交": "En espera de envío",
  "附件说明": "Descripción de los archivos adjuntos",
  "查看示例": "Ver ejemplo",
  "工商登记号码": "N.º de registro comercial",
  "去填写": "Agregar información",
  "待办理": "No finalizado",
  "账户状态：": "Estatus de la cuenta: ",
  "设备铺设结果": "Resultado de configuración del dispositivo",
  "上传失败，请重新上传": "No se pudo cargar, intenta de nuevo",
  "支持上传附件，含关键信息页需单独拍照上传至【执照照片】": "Se pueden cargar archivos adjuntos. Se debe tomar una foto de la página de información clave y cargarla por separado a [foto de la licencia].",
  "签约中": "En progreso",
  "不需要pad": "No se requiere pad",
  "高端饭店不做外卖": "Restaurante de alta categoría sin servicio de comida para llevar.",
  "最多%d个": "Máximo %d",
  "合同编号": "Número de contrato",
  "门店POI": "Ubicación de la tienda",
  "开店信息": "Información para abrir tienda",
  "商家开店检查": "Inspección de la tienda",
  "KP电话（仅支持手机）": "Teléfono del representante de la tienda (solo teléfono móvil)",
  "关联签约主体名称": "Nombre del signatario relacionado",
  "法人姓片假名": "Persona jurídica Apellido Katakana",
  "成功": "Correcto",
  "开始时间": "Hora de inicio",
  "审批邮件": "Correo de aprobación",
  "门店品类": "Categorías de tienda",
  "运营数据": "Datos de Operación",
  "新建商机": "Agregar nuevo Lead",
  "任务基础信息": "Información de la tarea",
  "食堂订单量（单/周）": "Capacidad del establecimiento(Pedidos por semana)",
  "新版": "Versión nueva",
  "需要": "Sí",
  "佣金策略合同模板": "Contrato con subvención de comisiones",
  "任务详情": "Detalles de la tarea",
  "预计参加：DiDi配置": "Está pensando en participar: configurado por DiDi",
  "请选择等待原因": "Seleccionar razón para esperar",
  "信息尚未保存，是否保存？": "Tienes cambios sin guardar. ¿Deseas guardarlos?",
  "请选择接收人": "Seleccionar destinatario",
  "股份有限公司": "Personas Jurídica - Sociedad Anónima",
  "乙方联系人头衔": "Cargo de quien firma",
  "处理时间": "Procesado en",
  "打款": "Pago",
  "资质类型": "Tipo de calificacion",
  "门店价值": "Valor de la tienda",
  "编辑": "Editar",
  "当前位置距商家": "La ubicación actual está a",
  "商家是否在线：": "Estado en línea: ",
  "护照": "Pasaporte",
  "发起验证申请": "Verifica la cuenta de pago.",
  "银行账户number": "Número de cuenta bancaria",
  "请填写真实原因": "Especifica el motivo real",
  "不能超过%d": "No puede exceder el %d",
  "公证日期": "Fecha de autenticación ante notario",
  "已签章": "Contrato fírmado",
  "商户留存措施": "Medidas de retención de la tienda",
  "自配送": "Entregas directas",
  "失败原因详情": "Motivo de desaprobación",
  "金额(円)": "Total(円)",
  "土地使用许可证执照照片": "Foto del permiso",
  "签约": "Firmar el contrato",
  "任务": "Tarea",
  "首次完成签约时间": "Hora de la primera firma",
  "当前门店总数=未签约门店+签约中门店+已签约门店": "Número total de tiendas = Tiendas aún sin contrato firmado + Tiendas en proceso de firma + Tiendas con contrato firmado",
  "上传最大数量为%d张，图片上限为%dM": "Carga hasta %d imágenes, tamaño máximo de la imagen %d MB",
  "法人名": "Persona jurídica Nombre",
  "个人": "Persona física",
  "确定合作，准备收集资料": "Colaboración confirmada, prepararse para la recopilación de información",
  "上传最大数量为1张，图片上限为5MB": "Tamaño máximo del archivo 5 MB, máximo 1 imagen",
  "乙方联系方式是超级管理员账户": "La información de contacto de la Parte B es una cuenta de súper administrador",
  "乙方联系人名": "Información de contacto de la otra parte Nombre",
  "乙方联系人姓片假名": "Información de contacto de la otra parte Apellido Katakana",
  "有效在线商户数": "Tiendas efectivamente en línea",
  "歇业中": "Tienda cerrada",
  "基础信息": "Información básica",
  "销售电话": "N.º de teléfono del representante de DiDi",
  "重复门店与创建门店的距离": "Distancia entre el socio potencial duplicado y la nueva tienda",
  "门店": "Tienda",
  "全部区域": "Todas las regiones",
  "拆迁": "Relocalizado",
  "请选择失败原因": "Especifica el motivo del error",
  "搜索记录": "Historial de búsqueda",
  "门店地址片假名": "Dirección de la tienda Katakana",
  "未添加": "No añadido",
  "加载中": "cargando",
  "请输入12位有效数字": "Escribe un número de 12 dígitos válido",
  "不愿上线": "No está dispuesta a conectarse",
  "CKA/KA BD": "CKA/KA BD",
  "完成电话": "Llamada finalizada",
  "乙方名称": "Nombre de Representante legal/ Persona Física",
  "更新时间": "Tiempo de Renovación",
  "标准合同模板": "Contrato de modelo estándar",
  "签约状态（多选）": "Estado del contrato (seleccionar múltiples)",
  "12位数，法人登记簿上的号码": "12 dígitos, el número en el registro de persona jurídica",
  "请在Gattaran查看": "Ver más información en Gattaran",
  "被授权人证件照片": "Foto de identificación del agente",
  "希望解约/回收pad": "Desea terminar el contrato/devolver la tableta",
  "乙方联系方式（仅支持手机）": "Teléfono celular del contacto principal de la empresa/ del propietario (Superadministrador)",
  "附件类型": "Tipo de archivo adjunto",
  "计划完成设置": "Está pensando en finalizar la configuración",
  "有合作意向": "Tiene interés en asociarse",
  "非餐饮": "Sin comida y bebida",
  "附件文件": "Documentos suplementarios",
  "法人信息": "Información de la empresa",
  "点击上传": "Cargar",
  "扣费次数": "Deducciones",
  "培训使用方法": "Entrenamiento de manejo de sistema",
  "陌拜": "Llamada en frío",
  "已完成改善": "Mejoras finalizadas",
  "扣费比例": "Proporción de deducción",
  "预定上线": "Está pensando en conectarse",
  "没有更多数据了": "No hay más datos disponibles",
  "未知": "Desconocido",
  "提交": "Enviar",
  "填写拜访信息": "Haz un resumen de la visita",
  "新功能培训": "Capacitación sobre nuevas características/funciones",
  "详细录入规则": "Normas detalladas",
  "不再发放": "No se harán nuevas concesiones",
  "门店详情": "Detalles de la tienda",
  "提交时间": "Enviado el",
  "登记簿": "Registrarse",
  "备注": "Observaciones",
  "不在线": "Desconectado",
  "提交后将无法正常签约": "El proceso normal de firma no estará disponible después del envío",
  "铺设成功": "Éxito",
  "催促商家首次上线": "Recordar a la tienda que se conecte por primera vez",
  "对公": "Pública",
  "商户运营价值": "Rango de la tienda",
  "米": "m de la tienda",
  "创建失败": "Error",
  "已核准": "Aprobado/a",
  "确认签章时需上传合同附件，请在Gattaran完成确认！": "Al verificar una firma, debes cargar los anexos del contrato. Completa la verificación en Gattaran.",
  "提交至审批": "Enviar para su aprobación",
  "在线状态：": "Abierto:",
  "资质信息": "Validaciones",
  "物料发放": "Concesión de los suministros",
  "姓名": "Nombre",
  "Opening Call": "Llamada de apertura",
  "两次银行卡号不一致！": "Clabe no coincide",
  "取消": "Cancelar",
  "法人证件": "Foto de IFE/INE del compañía",
  "门店营业时间": "Período de actividad del socio potencial",
  "无法获取应用版本信息": "No se pudo recuperar la información de la versión de la app",
  "商家位置为": "Ubicación de la tienda",
  "Curp号必须为大写字母": "La CURP debe ir en mayúsculas",
  "活动招商": "Promociones del evento",
  "墨西哥": "Mexico",
  "资料录入": "Ingresar datos",
  "地区与语言": "Región e idioma",
  "平台配送佣金比例": "Cuota de Servicio（Entrega mediante la Plataforma）",
  "待完成": "En curso",
  "开户公司名": "Nombre de la empresa que abre la cuenta",
  "选项和输入框不能为空": "Todos los campos obligatorios deben ser completados",
  "邮件&短信已发送给商家": "Correo electrónico y SMS enviados a la tienda",
  "您提交的无效原因有误，请检查": "El motivo no válido que envió es incorrecto, verifique",
  "本模块支持上传文件，可至PC端操作": "Los documentos se pueden subir a través de la versión para PC de la app",
  "确定要验证当前店铺的银行卡号？点击【确定】发起【支付验证】申请": "¿Seguro que quieres verificar la cuenta bancaria de la tienda actual? Presiona «OK» para verificar.",
  "发送邮件&短信": "Enviar correo electrónico y SMS",
  "正常门店": "Tienda normal",
  "设备铺设": "Configuración del dispositivo",
  "销售数据": "Datos de ventas",
  "请选择无效原因": "Seleccionar razón de la invalidez"
}